import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import { Formik, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';
import * as Yup from 'yup';
import { Card, CardContent, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import { createGenInfoRequestSave, getGenInfoRequest } from '../../store/actions/index';
import { CommonConfig } from '../../../../config/common-config';
import './styles.css';
import moment from 'moment';
import PreviewModal from '../../../../components/modal/previewModal';
import Viewer from 'react-viewer';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import PreviewImage from '../../../../assets/previewImage.png';
import downloadImage from '../../../../assets/downloadImage.png';
import Tooltip from '@material-ui/core/Tooltip';
import fieldDisable from '../../../../components/disableField/fieldDisable';
import { userType } from '../../../../config/usertypeValue';

const useStyles = makeStyles((theme) => ({
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '20px',
        [theme.breakpoints.down('sm')]: {
            top: '12px',
            fontSize: '11px',
        },
    },

    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },

    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },
    margin: {
        margin: theme.spacing(1),
    },
    textField: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(1),
        width: '100%',
        color: '#919191',
        fontSize: '15px',
        fontWeight: '300',
        borderBottom: '1px solid #ccc !important',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },

    heading: {
        fontSize: theme.typography.pxToRem(20),
        fontWeight: 700,
        color: '#4c4c4d',
        margin: theme.spacing(2),
        fontFamily: 'Rubik',
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    relevenceDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'flex',
            padding: '0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    noteView: {
        color: '#5D5D5D',
        fontFamily: 'Rubik',
        paddingTop: '4px',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
export default function ClientCheckListGenetator(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [isDisable, setIsDisable] = useState(true);
    const [preview, setPreview] = useState();
    const [URLValue, setURLValue] = useState();
    const [handleOpen, setHandleOpen] = useState(false);
    const [clearData, setClearData] = useState('');
    const [filename, setFilename] = useState('');
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [checklist, setChecklist] = useState('');
    // const [checklistID, setChecklistID] = useState('');
    // console.log("checklistID",
    //     checklistID.stageId);
    const [ultimateClient, setUltimateClient] = useState('');
    // console.log("ultimateClient", ultimateClient);
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [handleOpenNew, setHandleOpenNew] = useState(false);
    const [clearDataNew, setClearDataNew] = useState('');
    const [isfileInvalidNew, setIsfileInvalidNew] = useState('');
    const [selectedFileDataNew, setSelectedFileDataNew] = useState(null);
    const [filenameNew, setFilenameNew] = useState('');
    const [uploadSuccessfullyNew, setUploadSuccessfullyNew] = useState('');
    const [isDisableNew, setIsDisableNew] = useState(true);
    const [attachedFilePan, setAttachedFilePan] = useState('');
    // const [pathExtension, setPathExtension] = useState('');
    // console.log('setPathExtension', pathExtension);
    // console.log('attachedFilePanTTTTT', attachedFilePan);
    const [attachedFileAadhar, setAttachedFileAadhar] = useState('');
    const [attachedFileGSTIN, setAttachedFileGSTIN] = useState('');
    const [selectedImc, setselectedImc] = useState('');
    const [visible, setVisible] = React.useState(false);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [attachedFileEnrollment, setAttachedFileEnrollment] = useState('');
    const [relevanceList, setRelevanceList] = useState([
        { color: '#3ccbcb', name: 'Relevant' },
        { color: '#db466b', name: 'Irrelevant' },
        { color: '#FFC300', name: 'Partially Relevant' },
    ]);
    const [downloadFile, setDownloadFile] = useState('');
    // console.log('downloadFileyyyyy', downloadFile);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const userName = userDetails.result && userDetails.result.data.userName;
    const clientType = userDetails.result && userDetails.result.data.userType;
    // console.log("clientType", clientType);
    const userDomain = userDetails.result && userDetails.result.config.data;
    const [allCities, setAllCities] = useState([]);
    const [allStates, setAllStates] = useState([]);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState('');
    const [selectedState, setselectedState] = useState('');
    const [selectedCity, setselectedCity] = useState('');
    const [handleOpenPan, setHandleOpenPan] = useState(false);
    const [clearDataPan, setClearDataPan] = useState('');
    const [isfileInvalidPan, setIsfileInvalidPan] = useState('');
    console.log('TestData', isfileInvalidPan);
    const [selectedFileDataPan, setSelectedFileDataPan] = useState(null);
    const [filenamePan, setFilenamePan] = useState('');
    const [uploadSuccessfullyPan, setUploadSuccessfullyPan] = useState('');
    const [isDisablePan, setIsDisablePan] = useState(true);
    const [URLValuePan, setURLValuePan] = useState();
    // console.log('URLValuePannnnnn', URLValuePan);
    const [handleOpenGstin, setHandleOpenGstin] = useState(false);
    const [clearDataGstin, setClearDataGstin] = useState('');
    const [isfileInvalidGstin, setIsfileInvalidGstin] = useState('');
    const [selectedFileDataGstin, setSelectedFileDataGstin] = useState(null);
    const [filenameGstin, setFilenameGstin] = useState('');
    const [uploadSuccessfullyGstin, setUploadSuccessfullyGstin] = useState('');
    const [isDisableGstin, setIsDisableGstin] = useState(true);
    const [URLValueGstin, setURLValueGstin] = useState();
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const statusIDValue = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const downloadPath = `${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${URLValuePan}`;
    // const downloadPath = `${URLValuePan}`;
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const statusId = (checklist && checklist.currentStage && checklist.currentStage.id) || statusIDValue;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const [files, setFiles] = useState([]);
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [checklistFlag, setChecklistFlag] = useState();

    const handleBack = () => {
        history.push('/menu/openservice');
    };

    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, axiosConfig)
            .then((response) => {
                setAllCountries(response.data);
            })
            .catch((error) => {});
    };
    const fetchStateData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/country/${data}/getStates`, axiosConfig)
            .then((response) => {
                setAllStates(response.data);
            })
            .catch(() => {});
    };
    const fetchCityData = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/state/${data}/getCities`, axiosConfig)
            .then((response) => {
                //  //console.log('THE FETCHED DATA : ', response);
                setAllCities(response.data);
            })
            .catch(() => {});
    };
    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        fetchStateData(e.target.value);
    };
    const setState = (e) => {
        setselectedState(e.target.value);
        fetchCityData(e.target.value);
    };
    const setCity = (e) => {
        setselectedCity(e.target.value);
    };
    const handleClick = () => {
        setHandleOpen(true);
        setClearData('');
        setFilename('');
        setIsDisable(true);
    };

    const handleClose = () => {
        setShowBtnLoader(false);
        setHandleOpen(false);
        setIsfileInvalid('');
        setUploadSuccessfully('');
    };

    useEffect(() => {
        //console.log('statusIdView', statusId)
        var valueCountry = null;
        var valueState = null;
        let JsonUserDomain = {
            tennantName: '',
        };
        if (userDomain) {
            JsonUserDomain = JSON.parse(userDomain);
        }

        axios
            .get(
                `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                }/${serviceIdValue}`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                if (response && response.data && !response.data['checklistJson'].checklistL1) {
                    // console.log('tempObjView', response.data['checklistJson'].checklistL1)
                    setChecklistFlag(true);
                    setUltimateClientView();
                } else {
                    setChecklistFlag(false);
                }
            })
            .catch((error) => {});
        fetchCountryData();
        // console.log('userType.historyStageId, statusIDValue', userType.historyStageId, statusIDValue);
        if (userType.historyStageId <= statusIDValue) {
            // console.log('history view');
            // setShowLoader(true);

            // if (usertype === "Ultimate Client" && userType.value === "L2 Checklist") {
            //     console.log('inside active view');
            //     setShowLoader(true);
            //     axios
            //         .get(
            //             `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
            //             usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
            //             }/${serviceIdValue}`,
            //             {
            //                 headers: {
            //                     Authorization: bearerToken,
            //                 },
            //             }
            //         )
            //         .then((response) => {
            //             // if (response.data) {
            //             //     setShowLoader(false);
            //             // }
            //             setTimeout(() => {
            //                 setShowLoader(false);
            //             }, 3000);
            //             setChecklist(response.data);
            //             // setChecklistID(response.data.currentStage);
            //             setResponse(response, valueCountry, valueState);
            //         })
            //         .catch((error) => { });
            // } else {
            // console.log('inside history view');
            // setShowLoader(true);

            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                    }/${serviceIdValue}/${userType.historyStageId}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    // console.log('history response', response);
                    let tempObj = response.data;
                    tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                    // console.log('JSON.parse(response.data)', tempObj)
                    setChecklist(tempObj);
                    // setChecklistID(tempObj);
                    // setChecklistID(response.data);
                    setResponse(response, valueCountry, valueState);
                    // setShowLoader(false);
                })
                .catch((error) => {
                    // setShowLoader(false);
                });
            // }
        } else {
            // console.log('active view');
            setShowLoader(true);
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                    }/${serviceIdValue}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    // if (response.data) {
                    //     setShowLoader(false);
                    // }
                    setTimeout(() => {
                        setShowLoader(false);
                    }, 3000);
                    setChecklist(response.data);
                    setResponse(response, valueCountry, valueState);
                })
                .catch((error) => {
                    setShowLoader(false);
                });
        }
    }, [bearerToken, userType.value]);

    const setUltimateClientView = () => {
        var valueCountry = null;
        var valueState = null;
        let JsonUserDomain = {
            tennantName: '',
        };
        if (userDomain) {
            JsonUserDomain = JSON.parse(userDomain);
        }

        if (clientType === 'INDIVIDUAL') {
            axios
                .get(
                    `${CommonConfig.dev.baseUrl}/api/auth/s_uclient_Individual/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? JsonUserDomain.tennantName : imcNameSelected
                    }`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    if (response.data) {
                        setShowLoader(false);
                        // console.log('checklistFlag', checklistFlag)
                        // if (!checklistFlag) {
                        // console.log('checklist1', checklist1)
                        let ultimateClientObject = response.data.filter(function (e) {
                            return e.primarycontEmailid == userName;
                        });
                        if (valueCountry === null && valueState === null && ultimateClientObject.length > 0) {
                            setUltimateClient(ultimateClientObject);
                            let tempFile = '';
                            if (ultimateClientObject[0] && ultimateClientObject[0].panFiles) {
                                setAttachedFilePan(
                                    ultimateClientObject[0].panFiles.substring(ultimateClientObject[0].panFiles.lastIndexOf('/') + 1) || ''
                                );
                                setURLValuePan(ultimateClientObject[0].panFiles || '');
                                // setPathExtension(ultimateClientObject[0].panFiles.match(/\.(jpeg|jpg|gif|png|pdf)$/) !== null);
                            }
                            if (ultimateClientObject[0] && ultimateClientObject[0].adhaarFiles) {
                                setAttachedFileAadhar(
                                    ultimateClientObject[0].adhaarFiles.substring(
                                        ultimateClientObject[0].adhaarFiles.lastIndexOf('/') + 1
                                    ) || ''
                                );
                            }

                            if (ultimateClientObject[0] && ultimateClientObject[0].enrollmentFiles) {
                                setAttachedFileEnrollment(
                                    ultimateClientObject[0].enrollmentFiles.substring(
                                        ultimateClientObject[0].enrollmentFiles.lastIndexOf('/') + 1
                                    ) || ''
                                );
                            }
                            if (ultimateClientObject[0].enrollmentFiles) {
                                tempFile = ultimateClientObject[0].enrollmentFiles;
                            }
                            if (ultimateClientObject[0].adhaarFiles) {
                                tempFile = ultimateClientObject[0].adhaarFiles;
                            }
                            setURLValue(tempFile || '');
                            if (ultimateClientObject[0] && ultimateClientObject[0].gstinFiles) {
                                setAttachedFileGSTIN(
                                    ultimateClientObject[0].gstinFiles.substring(ultimateClientObject[0].gstinFiles.lastIndexOf('/') + 1) ||
                                        ''
                                );
                                setURLValueGstin(ultimateClientObject[0].gstinFiles || '');
                            }
                            valueCountry =
                                ultimateClientObject && ultimateClientObject[0].addressId && ultimateClientObject[0].addressId.country;
                            fetchStateData(valueCountry);
                            valueState =
                                ultimateClientObject &&
                                ultimateClientObject[0].addressId &&
                                ultimateClientObject[0].addressId.stateId.stateName;
                            fetchCityData(valueState);
                        }
                        // }
                    }
                });
        }

        if (clientType === 'CORPORATE') {
            axios
                .get(
                    `${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? JsonUserDomain.tennantName : imcNameSelected
                    }`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    // console.log("ultimate_corp_client-response", response.data);

                    if (response.data) {
                        setShowLoader(false);
                        // console.log('checklistFlag', checklistFlag)
                        // if (!checklistFlag) {
                        // console.log('checklist1', checklist1)
                        let ultimateClientObject = response.data.content.filter(function (e) {
                            return e.person1Emailid === userName;
                        });
                        if (valueCountry === null && valueState === null && ultimateClientObject.length > 0) {
                            setUltimateClient(ultimateClientObject);
                            let tempFile = '';
                            if (ultimateClientObject[0] && ultimateClientObject[0].panFiles) {
                                setAttachedFilePan(
                                    ultimateClientObject[0].panFiles.substring(ultimateClientObject[0].panFiles.lastIndexOf('/') + 1) || ''
                                );
                                setURLValuePan(ultimateClientObject[0].panFiles || '');
                            }
                            if (ultimateClientObject[0] && ultimateClientObject[0].adhaarFiles) {
                                setAttachedFileAadhar(
                                    ultimateClientObject[0].adhaarFiles.substring(
                                        ultimateClientObject[0].adhaarFiles.lastIndexOf('/') + 1
                                    ) || ''
                                );
                            }

                            if (ultimateClientObject[0] && ultimateClientObject[0].enrollmentFiles) {
                                setAttachedFileEnrollment(
                                    ultimateClientObject[0].enrollmentFiles.substring(
                                        ultimateClientObject[0].enrollmentFiles.lastIndexOf('/') + 1
                                    ) || ''
                                );
                            }
                            if (ultimateClientObject[0].enrollmentFiles) {
                                tempFile = ultimateClientObject[0].enrollmentFiles;
                            }
                            if (ultimateClientObject[0].adhaarFiles) {
                                tempFile = ultimateClientObject[0].adhaarFiles;
                            }
                            setURLValue(tempFile || '');
                            if (ultimateClientObject[0] && ultimateClientObject[0].gstFiles) {
                                setAttachedFileGSTIN(
                                    ultimateClientObject[0].gstFiles.substring(ultimateClientObject[0].gstFiles.lastIndexOf('/') + 1) || ''
                                );
                                setURLValueGstin(ultimateClientObject[0].gstFiles || '');
                            }
                            valueCountry =
                                ultimateClientObject && ultimateClientObject[0].addressId && ultimateClientObject[0].addressId.country;
                            fetchStateData(valueCountry);
                            valueState =
                                ultimateClientObject &&
                                ultimateClientObject[0].addressId &&
                                ultimateClientObject[0].addressId.stateId.stateName;
                            fetchCityData(valueState);
                        }
                        // }
                    }
                });
        }
    };

    const setResponse = (response, valueCountry, valueState) => {
        let temp = [];
        let flag = true;
        for (let i = 0; i < response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields.length; i++) {
            if (response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields[i].relevanceResponseAM === 'uploadFile') {
                flag = false;
                let tempObj = {
                    filePath: response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields[i].response,
                };
                temp.push(tempObj);
            }
        }
        if (!flag) {
            setFiles(temp);
        }

        if (response && response.data.checklistJson.checklistL1.questions[0].fields[19].response) {
            setAttachedFilePan(
                (response && response.data.checklistJson.checklistL1.questions[0].fields[19].response).substring(
                    response.data.checklistJson.checklistL1.questions[0].fields[19].response.lastIndexOf('/') + 1
                ) || ''
            );
            setURLValuePan((response && response.data.checklistJson.checklistL1.questions[0].fields[19].response) || '');
            setAttachedFileAadhar(
                (response && response.data.checklistJson.checklistL1.questions[0].fields[20].response).substring(
                    response.data.checklistJson.checklistL1.questions[0].fields[20].response.lastIndexOf('/') + 1
                ) || ''
            );

            setAttachedFileEnrollment(
                (response && response.data.checklistJson.checklistL1.questions[0].fields[20].response).substring(
                    response.data.checklistJson.checklistL1.questions[0].fields[20].response.lastIndexOf('/') + 1
                ) || ''
            );

            setURLValue((response && response.data.checklistJson.checklistL1.questions[0].fields[20].response) || '');
            setAttachedFileGSTIN(
                (response && response.data.checklistJson.checklistL1.questions[0].fields[22].response).substring(
                    response.data.checklistJson.checklistL1.questions[0].fields[22].response.lastIndexOf('/') + 1
                ) || ''
            );
            setURLValueGstin((response && response.data.checklistJson.checklistL1.questions[0].fields[22].response) || '');
        }
        dispatch(getGenInfoRequest(response.data.checklistJson.checklistL1));
        valueCountry = response.data.checklistJson.checklistL1 && response.data.checklistJson.checklistL1.questions[0].fields[8].response;
        valueState = response.data.checklistJson.checklistL1 && response.data.checklistJson.checklistL1.questions[0].fields[7].response;
        setURLValue(response.data.checklistJson.checklistL1 && response.data.checklistJson.checklistL1.questions[0].fields[16].response);
        if (valueCountry !== null && valueState !== null) {
            fetchStateData(valueCountry);
            fetchCityData(valueState);
        }
    };

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const allStateOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.state_name}>{data.state_name}</option>);
        return OptionList;
    };
    const allCityOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.city_name}>{data.city_name}</option>);
        return OptionList;
    };

    const initialValues = {
        firstName:
            clientType === 'CORPORATE'
                ? 'NaN'
                : (checklist1 && checklist1.questions[0].fields[0].response) || (ultimateClient && ultimateClient[0].firstName) || '',
        lastName:
            (checklist1 && checklist1.questions[0].fields[1].response) ||
            (ultimateClient && ultimateClient[0].lastName) ||
            (ultimateClient && ultimateClient[0].corpClientName) ||
            '',
        fatherNamePan: (checklist1 && checklist1.questions[0].fields[2].response) || '',
        pan: (checklist1 && checklist1.questions[0].fields[3].response) || (ultimateClient && ultimateClient[0].pan) || '',
        address1:
            (checklist1 && checklist1.questions[0].fields[4].response) ||
            (ultimateClient && ultimateClient[0].addressId && ultimateClient[0].addressId.addressLine1) ||
            '',
        address2:
            (checklist1 && checklist1.questions[0].fields[5].response) ||
            (ultimateClient && ultimateClient[0].addressId && ultimateClient[0].addressId.addressLine2) ||
            '',
        city:
            (checklist1 && checklist1.questions[0].fields[6].response) ||
            (ultimateClient && ultimateClient[0].addressId && ultimateClient[0].addressId.city) ||
            '',
        state:
            (checklist1 && checklist1.questions[0].fields[7].response) ||
            (ultimateClient && ultimateClient[0].addressId && ultimateClient[0].addressId.stateId.stateName) ||
            '',
        country:
            (checklist1 && checklist1.questions[0].fields[8].response) ||
            (ultimateClient && ultimateClient[0].addressId && ultimateClient[0].addressId.country) ||
            '',
        pin:
            (checklist1 && checklist1.questions[0].fields[9].response) ||
            (ultimateClient && ultimateClient[0].addressId && ultimateClient[0].addressId.pinCode) ||
            '',
        dob: (checklist1 && checklist1.questions[0].fields[10].response) || (ultimateClient && ultimateClient[0].dob) || '',
        mobileNo:
            (checklist1 && checklist1.questions[0].fields[11].response) ||
            (ultimateClient && ultimateClient[0].primarycontMobnumber) ||
            (ultimateClient && ultimateClient[0].person1Mobile) ||
            '',
        emailaddress:
            (checklist1 && checklist1.questions[0].fields[12].response) ||
            (ultimateClient && ultimateClient[0].primarycontEmailid) ||
            (ultimateClient && ultimateClient[0].person1Emailid) ||
            '',
        passport: (checklist1 && checklist1.questions[0].fields[13].response) || '',
        govIDType: (checklist1 && checklist1.questions[0].fields[14].response) || 'aadharNo',
        govIDNumber:
            (checklist1 && checklist1.questions[0].fields[15].response) || (ultimateClient && ultimateClient[0].aadharNumber) || '',
        URLValue: URLValue,
        radiodata: (checklist1 && checklist1.questions[0].fields[17].response) || 'Yes',
        GSTIN:
            (checklist1 && checklist1.questions[0].fields[18].response) ||
            (ultimateClient && ultimateClient[0].gstinNumber) ||
            (ultimateClient && ultimateClient[0].gstin) ||
            '',

        // screen 3 - Tab 1 - salary
        nameEmployer: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[1].response,
        salaryradiodata: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[0].response,
        url: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[2].response,
        //screen 3 - Tab 2 - hosuse property
        incomeFromHouseProperty: (checklist1que && checklist1que[2].subQuestion[1].response) || 'Yes',
        // screeen 3 - Tab 3 -Business
        incomeFromBusinessProfesion: (checklist1que && checklist1que[2].subQuestion[2].response) || 'Yes',
        natureBusiness: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].response,
        natureBusinessCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceResponseCRC,
        natureBusinessCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceRemarksCRC,

        busProfincomeType: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].response,
        busProfincomeTypeCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceResponseCRC,
        busProfincomeTypeCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceRemarksCRC,

        totalReceipts: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].response,
        totalReceiptsCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceResponseCRC,
        totalReceiptsCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceRemarksCRC,

        totalExpenses: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].response,
        totalExpensesCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceResponseCRC,
        totalExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceRemarksCRC,

        gstReturnDoc: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].response,
        gstReturnDocCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceResponseCRC,
        gstReturnDocCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceRemarksCRC,

        otherStatement: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].response,
        otherStatementCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceResponseCRC,
        otherStatementCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceRemarksCRC,

        busProfType: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].response,
        busProfTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceResponseCRC,
        busProfTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceRemarksCRC,

        userIDtally: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].response,
        userIDtallyCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceResponseCRC,
        userIDtallyCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceRemarksCRC,

        passwordtally: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].response,
        passwordtallyCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceResponseCRC,
        passwordtallyCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceRemarksCRC,

        uploadTally: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].response,
        uploadTallyCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceResponseCRC,
        uploadTallyCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceRemarksCRC,

        userIDZoho: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].response,
        userIDZohoCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceResponseCRC,
        userIDZohoCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceRemarksCRC,

        passwordZoho: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].response,
        passwordZohoCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceResponseCRC,
        passwordZohoCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceRemarksCRC,

        userIDQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].response,
        userIDQBCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceResponseCRC,
        userIDQBCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceRemarksCRC,

        passwordQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].response,
        passwordQBCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceResponseCRC,
        passwordQBCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceRemarksCRC,

        accountDetails: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].response,
        accountDetailsCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceResponseCRC,
        accountDetailsCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceRemarksCRC,

        partnershipradio: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].response,
        partnershipradioCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceResponseCRC,
        partnershipradioCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceRemarksCRC,

        totalReceiptsUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[14].response,
        totalExpensesUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[15].response,
        gstUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[16].response,
        statementUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[17].response,
        //screen 3 - Tab 4 - capitalGain
        soldAnyAsset: (checklist1que && checklist1que[2].subQuestion[3].response) || 'Yes',
        //screen 3 - Tab 5 - OtherSources
        explicitlyUncoveredIncom: (checklist1que && checklist1que[2].subQuestion[4].response) || 'Yes',
        // screen 3 - Tab 6 - Agri
        agricultureIncome: (checklist1que && checklist1que[2].subQuestion[5].response) || 'Yes',
        agricultureName: checklist1que && checklist1que[2].subQuestion[5].fields[0].response,
        agricultureNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[0].relevanceResponseCRC,
        agricultureNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[0].relevanceRemarksCRC,
        agriAmount: checklist1que && checklist1que[2].subQuestion[5].fields[1].response,
        agriAmountCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[1].relevanceResponseCRC,
        agriAmountCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[1].relevanceRemarksCRC,
        agriReceipt: checklist1que && checklist1que[2].subQuestion[5].fields[2].response,
        agriReceiptCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[2].relevanceResponseCRC,
        agriReceiptCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[2].relevanceRemarksCRC,
        agriExpenses: checklist1que && checklist1que[2].subQuestion[5].fields[3].response,
        agriExpensesCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[3].relevanceResponseCRC,
        agriExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[3].relevanceRemarksCRC,
        agriReceiptUpload: checklist1que && checklist1que[2].subQuestion[5].fields[4].response,
        agriExpensesUpload: checklist1que && checklist1que[2].subQuestion[5].fields[5].response,
        // Travel outside
        traveloutsideType: checklist1 && checklist1.questions[4].fields[0].response,
        // Screen 6
        directorType: checklist1 && checklist1.questions[5].fields[0].response,
        // Screen 7
        assetradio: checklist1 && checklist1.questions[6].subQuestion[11].fields[0].response,

        // totalIncome
        totalincomeradio: checklist1 && checklist1.questions[7].subQuestion[5].fields[0].response,
    };
    // const initialValues = {};

    // Screen 2
    let bankDetailsArr = [];

    if (checklist1que && checklist1que[1].fields.length > 1) {
        for (let i = 0; i < checklist1que[1].fields.length; i += 7) {
            let bankDetailsArrtemp = {
                bankName: checklist1que[1].fields[i].response,
                bankNameRelevance: checklist1que[1].fields[i].relevanceResponseCRC,
                bankNameRelevanceRemarks: checklist1que[1].fields[i].relevanceRemarksCRC,

                accountNumber: checklist1que[1].fields[i + 1].response,
                accountNoRelevance: checklist1que[1].fields[i + 1].relevanceResponseCRC,
                accountNoRelevanceRemarks: checklist1que[1].fields[i + 1].relevanceRemarksCRC,

                ifscCode: checklist1que[1].fields[i + 2].response,
                ifscCodeRelevance: checklist1que[1].fields[i + 2].relevanceResponseCRC,
                ifscCodeRelevanceRemarks: checklist1que[1].fields[i + 2].relevanceRemarksCRC,

                typeOfAcc: checklist1que[1].fields[i + 3].response,
                accTypeRelevance: checklist1que[1].fields[i + 3].relevanceResponseCRC,
                accTypeRelevanceRemarks: checklist1que[1].fields[i + 3].relevanceRemarksCRC,

                interestOfSavingsBank: checklist1que[1].fields[i + 4].response,
                jointAccNameRelevance: checklist1que[1].fields[i + 4].relevanceResponseCRC,
                jointAccNameRelevanceRemarks: checklist1que[1].fields[i + 4].relevanceRemarksCRC,

                checkedBank: checklist1que[1].fields[i + 5].response,
                checkedBankRelevance: checklist1que[1].fields[i + 5].relevanceResponseCRC,
                checkedBankRelevanceRemarks: checklist1que[1].fields[i + 5].relevanceRemarksCRC,

                bankStatementUpload:
                    checklist1que && checklist1que[1] && checklist1que[1].fields[i + 6] && checklist1que[1].fields[i + 6].response,
            };
            bankDetailsArr.push(bankDetailsArrtemp);
        }
    } else {
        let bankDetailsArrtemp = {
            bankName: '',
            bankNameRelevance: '',
            bankNameRelevanceRemarks: '',

            accountNumber: '',
            accountNoRelevance: '',
            accountNoRelevanceRemarks: '',

            ifscCode: '',
            ifscCodeRelevance: '',
            ifscCodeRelevanceRemarks: '',

            typeOfAcc: '',
            accTypeRelevance: '',
            accTypeRelevanceRemarks: '',

            interestOfSavingsBank: '',
            jointAccNameRelevance: '',
            jointAccNameRelevanceRemarks: '',

            checkedBank: '',
            checkedBankRelevance: '',
            checkedBankRelevanceRemarks: '',

            bankStatementUpload: '',
        };
        bankDetailsArr.push(bankDetailsArrtemp);
    }
    initialValues.bankDetails = bankDetailsArr;

    // screen 3 - Tab 1 - Salary
    const investmentArr = [];

    if (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[0].subSubQuestions[1].fields.length; i += 3) {
            let investmentArrtemp = {
                investmentDetails: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].response,
                investmentDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                investmentDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                investmentAmt: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                investmentAmtCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                investmentAmtCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                invAmtUpload: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 2].response,
            };
            investmentArr.push(investmentArrtemp);
        }
    } else {
        const investmentArrtemp = {
            investmentDetails: '',
            investmentAmt: '',
            invAmtUpload: '',
        };
        investmentArr.push(investmentArrtemp);
    }
    initialValues.investment = investmentArr;

    const donationArr = [];

    if (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[0].subSubQuestions[2].fields.length; i += 3) {
            const donationArrtemp = {
                donationDetails: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].response,
                donationDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceResponseCRC,
                donationDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                donationAmt: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].response,
                donationAmountCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].relevanceResponseCRC,
                donationAmountCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].relevanceRemarksCRC,
                donationAmtUpload: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 2].response,
            };
            donationArr.push(donationArrtemp);
        }
    } else {
        const donationArrtemp = {
            donationDetails: '',
            donationAmt: '',
            donationAmtUpload: '',
        };
        donationArr.push(donationArrtemp);
    }
    initialValues.donation = donationArr;

    const tallyYesArr = [];

    if (checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields.length > 1) {
        for (let i = 0; i < checklist1que[2].subQuestion[2].subSubQuestions[1].fields.length; i += 9) {
            const tallyYesArrtemp = {
                nameFirm: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].response,
                nameFirmCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceResponseCRC,
                nameFirmCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                panNoFirm: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].response,
                panNoFirmCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                panNoFirmCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                remunRec: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].response,
                remunRecCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                remunRecCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
                amtInt: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].response,
                amtIntCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].relevanceResponseCRC,
                amtIntCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].relevanceRemarksCRC,
                shareProfit: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].response,
                shareProfitCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].relevanceResponseCRC,
                shareProfitCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].relevanceRemarksCRC,
                shareProfitRs: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].response,
                shareProfitRsCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].relevanceResponseCRC,
                shareProfitRsCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].relevanceRemarksCRC,
                firmAudit: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].response,
                firmAuditCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].relevanceResponseCRC,
                firmAuditCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].relevanceRemarksCRC,
                transferPrice: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].response,
                transferPriceCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].relevanceResponseCRC,
                transferPriceCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].relevanceRemarksCRC,
                balance: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].response,
                balanceCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].relevanceResponseCRC,
                balanceCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].relevanceRemarksCRC,
            };
            tallyYesArr.push(tallyYesArrtemp);
        }
    } else {
        const tallyYesArrtemp = {
            nameFirm: '',
            panNoFirm: '',
            remunRec: '',
            amtInt: '',
            shareProfit: '',
            shareProfitRs: '',
            firmAudit: '',
            transferPrice: '',
            balance: '',
        };
        tallyYesArr.push(tallyYesArrtemp);
    }
    initialValues.tallyYes = tallyYesArr;

    // screen 3 - Tab 2 -House prop
    const housepropertyArr = [];

    if (checklist1que && checklist1que[2].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[1].fields.length; i += 14) {
            // let coownerArr = [];
            // let housePropertyIndex = 0;
            let housepropertyArrtemp = {
                houseAddress: checklist1que[2].subQuestion[1].fields[i].response,
                houseAddressCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i].relevanceResponseCRC,
                houseAddressCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i].relevanceRemarksCRC,

                houseStatusType: checklist1que[2].subQuestion[1].fields[i + 1].response || 'letout',
                houseStatusTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                houseStatusTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].relevanceRemarks,

                rent: checklist1que[2].subQuestion[1].fields[i + 2].response,
                rentCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                rentCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                propTax: checklist1que[2].subQuestion[1].fields[i + 3].response,
                propTaxCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                propTaxCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                tenantName: checklist1que[2].subQuestion[1].fields[i + 4].response,
                tenantNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                tenantNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                pan: checklist1que[2].subQuestion[1].fields[i + 5].response,
                panCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                panCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                housepurposeType: checklist1que[2].subQuestion[1].fields[i + 6].response || 'commercial',
                housepurposeTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                housepurposeTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                propertyCoOwnedType: checklist1que[2].subQuestion[1].fields[i + 11].response || 'coownerYes',
                propertyCoOwnedTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].relevanceResponseCRC,
                propertyCoOwnedTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].relevanceRemarksCRC,

                rentUpload: checklist1que[2].subQuestion[1].fields[i + 7].response,
                // uploadCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                // uploadCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 7].relevanceRemarksCRC,

                propertyUpload: checklist1que[2].subQuestion[1].fields[i + 9].response,
                haveyoutakenanyhousingloanType: checklist1que[2].subQuestion[1].fields[i + 10].response || 'housingLoanyes',
                haveyoutakenanyhousingloanTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].relevanceResponseCRC,
                haveyoutakenanyhousingloanTypeCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].relevanceRemarksCRC,

                TDSdeductedinrentType: checklist1que[2].subQuestion[1].fields[i + 8].response || 'tdsyes',
                TDSdeductedinrentTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].relevanceResponseCRC,
                TDSdeductedinrentTypeCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].relevanceRemarksCRC,

                loanUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].response,
                loanUploadCRCrelevenceResponse:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].relevanceResponseCRC,
                loanUploadCRCrelevenceRemarks:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].relevanceRemarksCRC,

                TDSUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].response,
                TDSUploadCRCrelevenceResponse:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].relevanceResponseCRC,
                TDSUploadCRCrelevenceRemarks:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].relevanceRemarksCRC,
                coowner: [],
            };
            if (checklist1que[2].subQuestion[1].subSubQuestions.length > 0) {
                let coOwnerList = [];
                for (let j = 0; j < checklist1que[2].subQuestion[1].subSubQuestions.length; j += 3) {
                    if (checklist1que[2].subQuestion[1].subSubQuestions[j].sectionText.split('-').pop() == housepropertyArr.length) {
                        let coOwner = {
                            coownerName: checklist1que[2].subQuestion[1].subSubQuestions[j].response,
                            coownerNameCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].relevanceResponseCRC,
                            coownerNameCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].relevanceRemarksCRC,

                            coownerPan: checklist1que[2].subQuestion[1].subSubQuestions[j + 1].response,
                            coownerPanCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].relevanceResponseCRC,
                            coownerPanCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].relevanceRemarksCRC,

                            share: checklist1que[2].subQuestion[1].subSubQuestions[j + 2].response,
                            shareCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].relevanceResponseCRC,
                            shareCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].relevanceRemarksCRC,
                        };
                        coOwnerList.push(coOwner);
                    }
                }
                housepropertyArrtemp.coowner = coOwnerList;
            }
            housepropertyArr.push(housepropertyArrtemp);
        }
    } else {
        const housepropertyArrtemp = {
            houseAddress: '',
            houseStatusType: '',
            rent: '',
            propTax: '',
            tenantName: '',
            pan: '',
            housepurposeType: '',
            propertyCoOwnedType: '',
            coowner: [
                {
                    coownerName: '',
                    coownerPan: '',
                    share: '',
                },
            ],
            haveyoutakenanyhousingloanType: '',
            rentUpload: '',
            TDSdeductedinrentType: '',
            propertyUpload: '',
            loanUpload: '',
            TDSUpload: '',
        };
        housepropertyArr.push(housepropertyArrtemp);
    }
    initialValues.houseproperty = housepropertyArr;

    // screen 3 - Tab 4 -capital gain
    const capitalgainArr = [];

    if (checklist1que && checklist1que[2].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[3].fields.length; i += 2) {
            const capitalgainArrtemp = {
                natureAssets: checklist1que && checklist1que[2].subQuestion[3].fields[i].response,
                balanceCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[3].fields[i].relevanceResponseCRC,
                balanceCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[3].fields[i].relevanceRemarksCRC,
                natureAssetsUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[3] &&
                    checklist1que[2].subQuestion[3].fields[i + 1] &&
                    checklist1que[2].subQuestion[3].fields[i + 1].response,
            };
            capitalgainArr.push(capitalgainArrtemp);
        }
    } else {
        const capitalgainArrtemp = {
            natureAssets: '',
            natureAssetsUpload: '',
        };
        capitalgainArr.push(capitalgainArrtemp);
    }

    initialValues.capitalgain = capitalgainArr;

    // scrren 3 - Tab 5 - agriculture
    const agricultureArr = [];
    if (checklist1que && checklist1que[2].subQuestion[5].fields.length > 1) {
        //console.log('Field Length', checklist1que[4].fields.length);
        for (let i = 0; i < checklist1que[2].subQuestion[5].fields.length; i += 6) {
            const agricultureArrtemp = {
                agricultureName: (checklist1que && checklist1que[2].subQuestion[5].fields[i].response) || '',
                agricultureNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceResponseCRC,
                agricultureNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceRemarksCRC,
                agriAmount: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].response) || '',
                agriAmountCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                agriAmountCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceRemarksCRC,
                agriReceipt: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].response) || '',
                agriReceiptCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                agriReceiptCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceRemarksCRC,
                agriExpenses: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].response) || '',
                agriExpensesCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                agriExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceRemarksCRC,
                agriReceiptUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 4].response) || '',
                agriExpensesUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 5].response) || '',
            };
            agricultureArr.push(agricultureArrtemp);
        }
    } else {
        const agricultureArrtemp = {
            agricultureName: '',
            agriAmount: '',
            agriReceipt: '',
            agriExpenses: '',
            agriReceiptUpload: '',
            agriExpensesUpload: '',
        };
        agricultureArr.push(agricultureArrtemp);
    }
    initialValues.agriculture = agricultureArr;

    // screen 3 -Tab 5 - other source
    const dividentArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[0].fields.length; i += 3) {
            let dividenttempArr = {
                divPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].response,
                divPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceResponseCRC,
                divPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                divAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].response,
                divAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                divAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,
                divUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 2].response,
            };
            dividentArr.push(dividenttempArr);
        }
    } else {
        const dividenttempArr = {
            divPayer: '',
            divAmount: '',
            divUpload: '',
        };
        dividentArr.push(dividenttempArr);
    }

    initialValues.divident = dividentArr;

    const fdArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[1].fields.length; i += 3) {
            ////console.log('payer', checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1])
            ////console.log('Amount', checklist1que && checklist1que[2].subQuestion[4].subSubQuestions)
            let fdtempArr = {
                fdPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].response,
                fdPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceResponseCRC,
                fdPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                fdAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].response,
                fdAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                fdAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                fdUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 2].response,
            };
            fdArr.push(fdtempArr);
        }
    } else {
        const fdtempArr = {
            fdPayer: '',
            fdAmount: '',
            fdUpload: '',
        };
        fdArr.push(fdtempArr);
    }

    initialValues.fd = fdArr;

    const othersArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[2].fields.length; i += 3) {
            let othertempArr = {
                otherPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].response,
                otherPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceResponseCRC,
                otherPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                otherAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].response,
                otherAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].relevanceResponseCRC,
                otherAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].relevanceRemarksCRC,
                otherUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 2].response,
            };
            othersArr.push(othertempArr);
        }
    } else {
        const othertempArr = {
            otherPayer: '',
            otherAmount: '',
            otherUpload: '',
        };
        othersArr.push(othertempArr);
    }

    initialValues.othersources = othersArr;

    // Screen 5
    const travelOutsideArr = [];
    if (checklist1que && checklist1que[4].subQuestion[0].fields.length > 1) {
        //console.log('Field Length', checklist1que[4].fields.length);
        for (let i = 0; i < checklist1que[4].subQuestion[0].fields.length; i += 2) {
            const travelOutsideArrtemp = {
                year: checklist1que[4].subQuestion[0].fields[i].response,
                yearRelevance: checklist1que[4].subQuestion[0].fields[i].relevanceResponseCRC,
                yearRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i].relevanceRemarksCRC,
                daysIndia: checklist1que[4].subQuestion[0].fields[i + 1].response,
                daysIndiaRelevance: checklist1que[4].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                daysIndiaRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i + 1].relevanceRemarksCRC,
            };
            travelOutsideArr.push(travelOutsideArrtemp);
        }
    } else {
        const travelOutsideArrtemp = {
            year: '',
            yearRelevance: '',
            yearRelevanceRemarks: '',
            daysIndia: '',
            daysIndiaRelevance: '',
            daysIndiaRelevanceRemarks: '',
        };
        travelOutsideArr.push(travelOutsideArrtemp);
    }
    initialValues.travelOutside = travelOutsideArr;

    // Screen 6

    const directorArr = [];
    if (checklist1que && checklist1que[5].subQuestion[0].fields.length > 1) {
        for (let i = 0; i < checklist1que[5].subQuestion[0].fields.length; i += 4) {
            let directorArr1 = {
                companyName: checklist1que[5].subQuestion[0].fields[i].response,
                companyNameRelevance: checklist1que[5].subQuestion[0].fields[i].relevanceResponseCRC,
                companyNameRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i].relevanceRemarksCRC,

                panCompany: checklist1que[5].subQuestion[0].fields[i + 1].response,
                panCompanyRelevance: checklist1que[5].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                panCompanyRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 1].relevanceRemarksCRC,

                shares: checklist1que[5].subQuestion[0].fields[i + 2].response,
                sharesRelevance: checklist1que[5].subQuestion[0].fields[i + 2].relevanceResponseCRC,
                sharesRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 2].relevanceRemarksCRC,

                din: checklist1que[5].subQuestion[0].fields[i + 3].response,
                compDinRelevance: checklist1que[5].subQuestion[0].fields[i + 3].relevanceResponseCRC,
                compDinRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 3].relevanceRemarksCRC,
            };
            directorArr.push(directorArr1);
        }
    } else {
        const directorArr1 = {
            companyName: '',
            companyNameRelevance: '',
            companyNameRelevanceRemarks: '',

            panCompany: '',
            panCompanyRelevance: '',
            panCompanyRelevanceRemarks: '',

            shares: '',
            sharesRelevance: '',
            sharesRelevanceRemarks: '',

            din: '',
            compDinRelevance: '',
            compDinRelevanceRemarks: '',
        };
        directorArr.push(directorArr1);
    }
    initialValues.directorCompany = directorArr;

    const assetHomeArr1 = [];
    // Screen 7 -assetHome
    if (checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[0].subSubQuestions[0].fields.length; i += 9) {
            const assetHomeArr = {
                country: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].relevanceRemarksCRC,

                tpin: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].response,
                tpinRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                tpinRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,

                salA: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].response,
                salARelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].relevanceResponseCRC,
                salARelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].relevanceRemarksCRC,

                salB: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].response,
                salBRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].relevanceResponseCRC,
                salBRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].relevanceRemarksCRC,

                salC: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].response,
                salCRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].relevanceResponseCRC,
                salCRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].relevanceRemarksCRC,

                salD: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].response,
                salDRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].relevanceResponseCRC,
                salDRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].relevanceRemarksCRC,

                salE: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].response,
                salERelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].relevanceResponseCRC,
                salERelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].relevanceRemarksCRC,

                srcNature: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].response,
                srcNatureRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].relevanceResponseCRC,
                srcNatureRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].relevanceRemarksCRC,

                totIncome: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].response,
                totIncomeRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].relevanceResponseCRC,
                totIncomeRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].relevanceRemarksCRC,
            };
            assetHomeArr1.push(assetHomeArr);
        }
    } else {
        const assetHomeArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            tpin: '',
            tpinRelevance: '',
            tpinRelevanceRemarks: '',

            salA: '',
            salARelevance: '',
            salARelevanceRemarks: '',

            salB: '',
            salBRelevance: '',
            salBRelevanceRemarks: '',

            salC: '',
            salCRelevance: '',
            salCRelevanceRemarks: '',

            salD: '',
            salDRelevance: '',
            salDRelevanceRemarks: '',

            salE: '',
            salERelevance: '',
            salERelevanceRemarks: '',

            srcNature: '',
            srcNatureRelevance: '',
            srcNatureRelevanceRemarks: '',

            totIncome: '',
            totIncomeRelevance: '',
            totIncomeRelevanceRemarks: '',
        };
        assetHomeArr1.push(assetHomeArr);
    }
    initialValues.assetHome = assetHomeArr1;

    const assetNatureArr1 = [];
    // Screen 7 -assetNature
    if (checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[0].subSubQuestions[1].fields.length; i += 3) {
            const assetNatureArr = {
                incomeNature: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                incomeNatureRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,

                foreignAmount: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                foreignAmountRelevance:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                foreignAmountRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,

                foreignTaxes: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].response,
                foreignTaxesRelevance:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                foreignTaxesRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
            };
            assetNatureArr1.push(assetNatureArr);
        }
    } else {
        const assetNatureArr = {
            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',

            foreignAmount: '',
            foreignAmountRelevance: '',
            foreignAmountRelevanceRemarks: '',

            foreignTaxes: '',
            foreignTaxesRelevance: '',
            foreignTaxesRelevanceRemarks: '',
        };
        assetNatureArr1.push(assetNatureArr);
    }
    initialValues.assetNature = assetNatureArr1;

    const clientArr1 = [];
    // Screen 7 - Accordion 1
    if (checklist1que && checklist1que[6].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[1].fields.length; i += 9) {
            const clientArr = {
                country: checklist1que[6].subQuestion[1].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[1].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i].relevanceRemarksCRC,

                entityNature: checklist1que[6].subQuestion[1].fields[i + 1].response,
                entityNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                entityNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 1].relevanceRemarksCRC,

                entityName: checklist1que[6].subQuestion[1].fields[i + 2].response,
                entityName1Relevance: checklist1que[6].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                entityName1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                entityAddress: checklist1que[6].subQuestion[1].fields[i + 3].response,
                entityAddress1Relevance: checklist1que[6].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                entityAddress1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                interestNature: checklist1que[6].subQuestion[1].fields[i + 4].response,
                interestNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                interestNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                date: checklist1que[6].subQuestion[1].fields[i + 5].response,
                date1Relevance: checklist1que[6].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                date1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                totInvestment: checklist1que[6].subQuestion[1].fields[i + 6].response,
                totInvestment1Relevance: checklist1que[6].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                totInvestment1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                interestIncome: checklist1que[6].subQuestion[1].fields[i + 7].response,
                interstIncome1Relevance: checklist1que[6].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                interstIncome1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 7].relevanceRemarksCRC,

                incomeNature: checklist1que[6].subQuestion[1].fields[i + 8].response,
                incomeNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 8].relevanceResponseCRC,
                incomeNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr1.push(clientArr);
        }
    } else {
        const clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            entityNature: '',
            entityNature1Relevance: '',
            entityNature1RelevanceRemarks: '',

            entityName: '',
            entityName1Relevance: '',
            entityName1RelevanceRemarks: '',

            entityAddress: '',
            entityAddress1Relevance: '',
            entityAddress1RelevanceRemarks: '',

            interestNature: '',
            interestNature1Relevance: '',
            interestNature1RelevanceRemarks: '',

            date: '',
            date1Relevance: '',
            date1RelevanceRemarks: '',

            totInvestment: '',
            totInvestment1Relevance: '',
            totInvestment1RelevanceRemarks: '',

            interestIncome: '',
            interstIncome1Relevance: '',
            interstIncome1RelevanceRemarks: '',

            incomeNature: '',
            incomeNature1Relevance: '',
            incomeNature1RelevanceRemarks: '',
        };
        clientArr1.push(clientArr);
    }
    initialValues.client1 = clientArr1;

    const clientArr2 = [];
    // sCreen 7 - Accordion 2
    if (checklist1que && checklist1que[6].subQuestion[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[2].fields.length; i += 7) {
            const clientArr = {
                country: checklist1que[6].subQuestion[2].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[2].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[2].fields[i].relevanceRemarksCRC,

                propAddress: checklist1que[6].subQuestion[2].fields[i + 1].response,
                propAddressRelevance: checklist1que[6].subQuestion[2].fields[i + 1].relevanceResponseCRC,
                propAddressRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 1].relevanceRemarksCRC,

                ownership: checklist1que[6].subQuestion[2].fields[i + 2].response,
                ownershipRelevance: checklist1que[6].subQuestion[2].fields[i + 2].relevanceResponseCRC,
                ownershipRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 2].relevanceRemarksCRC,

                acqisitionDate: checklist1que[6].subQuestion[2].fields[i + 3].response,
                acqisitionDateRelevance: checklist1que[6].subQuestion[2].fields[i + 3].relevanceResponseCRC,
                acqisitionDateRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 3].relevanceRemarksCRC,

                totInvestment: checklist1que[6].subQuestion[2].fields[i + 4].response,
                totInvestmentRelevance: checklist1que[6].subQuestion[2].fields[i + 4].relevanceResponseCRC,
                totInvestmentRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 4].relevanceRemarksCRC,

                propIncome: checklist1que[6].subQuestion[2].fields[i + 5].response,
                propIncomeRelevance: checklist1que[6].subQuestion[2].fields[i + 5].relevanceResponseCRC,
                propIncomeRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 5].relevanceRemarksCRC,

                incomeNature: checklist1que[6].subQuestion[2].fields[i + 6].response,
                incomeNatureRelevance: checklist1que[6].subQuestion[2].fields[i + 6].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr2.push(clientArr);
        }
    } else {
        const clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            propAddress: '',
            propAddressRelevance: '',
            propAddressRelevanceRemarks: '',

            ownership: '',
            ownershipRelevance: '',
            ownershipRelevanceRemarks: '',

            acqisitionDate: '',
            acqisitionDateRelevance: '',
            acqisitionDateRelevanceRemarks: '',

            totInvestment: '',
            totInvestmentRelevance: '',
            totInvestmentRelevanceRemarks: '',

            propIncome: '',
            propIncomeRelevance: '',
            propIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr2.push(clientArr);
    }
    initialValues.client2 = clientArr2;

    const clientArr3 = [];
    // Screen 7 - Accordion 3
    if (checklist1que && checklist1que[6].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[3].fields.length; i += 7) {
            const clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[3].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[3].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i].relevanceRemarksCRC,

                assetName: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].response,
                assetNameRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].relevanceResponseCRC,
                assetNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].relevanceRemarksCRC,

                ownership: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].response,
                ownershipRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].relevanceResponseCRC,
                ownershipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].relevanceRemarksCRC,

                acqisitionDate: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].response,
                acqisitionDateRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].relevanceResponseCRC,
                acqisitionDateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].relevanceRemarksCRC,

                totInvestment: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].response,
                totInvestmentRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].relevanceResponseCRC,
                totInvestmentRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].relevanceRemarksCRC,

                assetIncome: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].response,
                assetIncomeRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].relevanceResponseCRC,
                assetIncomeRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].relevanceRemarksCRC,

                incomeNature: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr3.push(clientArr);
        }
    } else {
        const clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            assetName: '',
            assetNameRelevance: '',
            assetNameRelevanceRemarks: '',

            ownership: '',
            ownershipRelevance: '',
            ownershipRelevanceRemarks: '',

            acqisitionDate: '',
            acqisitionDateRelevance: '',
            acqisitionDateRelevanceRemarks: '',

            totInvestment: '',
            totInvestmentRelevance: '',
            totInvestmentRelevanceRemarks: '',

            assetIncome: '',
            assetIncomeRelevance: '',
            assetIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr3.push(clientArr);
    }
    initialValues.client3 = clientArr3;

    const clientArr4 = [];
    // Screen 7 - Accordion 4

    if (checklist1que && checklist1que[6].subQuestion[4].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[4].fields.length; i += 5) {
            let clientArr = {
                institutionName: checklist1que && checklist1que[6].subQuestion[4].fields[i].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].relevanceRemarksCRC,

                accholderName: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].response,
                accholderNameRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].relevanceResponseCRC,
                accholderNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].relevanceRemarksCRC,

                peakBal: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].response,
                peakBalRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].relevanceResponseCRC,
                peakBalRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].relevanceRemarksCRC,
            };
            clientArr4.push(clientArr);
        }
    } else {
        let clientArr = {
            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            accholderName: '',
            accholderNameRelevance: '',
            accholderNameRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            peakBal: '',
            peakBalRelevance: '',
            peakBalRelevanceRemarks: '',
        };
        clientArr4.push(clientArr);
    }

    initialValues.client4 = clientArr4;

    const clientArr5 = [];
    // Screen 7 - Accordion 5
    if (checklist1que && checklist1que[6].subQuestion[5].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[5].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[5].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[5].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i].relevanceRemarksCRC,

                trustName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].response,
                trustNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                trustNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].relevanceRemarksCRC,

                trustAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].response,
                trustAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                trustAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].relevanceRemarksCRC,

                trusteeName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].response,
                trusteeNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                trusteeNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].relevanceRemarksCRC,

                trusteeAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].response,
                trusteeAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].relevanceResponseCRC,
                trusteeAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].relevanceRemarksCRC,

                settlorAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].response,
                settlorAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].relevanceResponseCRC,
                settlorAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].relevanceRemarksCRC,

                settlorName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].response,
                settlorNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].relevanceResponseCRC,
                settlorNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].relevanceRemarksCRC,

                benfName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].response,
                benfNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].relevanceResponseCRC,
                benfNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].relevanceRemarksCRC,

                benfAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].response,
                benfAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].relevanceResponseCRC,
                benfAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr5.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            trustName: '',
            trustNameRelevance: '',
            trustNameRelevanceRemarks: '',

            trustAddress: '',
            trustAddressRelevance: '',
            trustAddressRelevanceRemarks: '',

            trusteeName: '',
            trusteeNameRelevance: '',
            trusteeNameRelevanceRemarks: '',

            trusteeAddress: '',
            trusteeAddressRelevance: '',
            trusteeAddressRelevanceRemarks: '',

            settlorAddress: '',
            settlorAddressRelevance: '',
            settlorAddressRelevanceRemarks: '',

            settlorName: '',
            settlorNameRelevance: '',
            settlorNameRelevanceRemarks: '',

            benfName: '',
            benfNameRelevance: '',
            benfNameRelevanceRemarks: '',

            benfAddress: '',
            benfAddressRelevance: '',
            benfAddressRelevanceRemarks: '',
        };
        clientArr5.push(clientArr);
    }
    initialValues.client5 = clientArr5;

    const clientArr6 = [];
    //        screen 7 - Accordion 6
    if (checklist1que && checklist1que[6].subQuestion[6].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[6].fields.length; i += 5) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[6].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[6].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i].relevanceRemarksCRC,

                personName: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].response,
                personNameRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].relevanceResponseCRC,
                personNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].relevanceRemarksCRC,

                personAddr: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].response,
                personAddrRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].relevanceResponseCRC,
                personAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].relevanceRemarksCRC,

                derivedIncome: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].response,
                derivedIncomeRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].relevanceResponseCRC,
                derivedIncomeRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].relevanceRemarksCRC,

                incomeNature: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].relevanceRemarksCRC,
            };
            clientArr6.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            personName: '',
            personNameRelevance: '',
            personNameRelevanceRemarks: '',

            personAddr: '',
            personAddrRelevance: '',
            personAddrRelevanceRemarks: '',

            derivedIncome: '',
            derivedIncomeRelevance: '',
            derivedIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr6.push(clientArr);
    }
    initialValues.client6 = clientArr6;

    const clientArr7 = [];
    // Screen 7 - Accordion 7
    if (checklist1que && checklist1que[6].subQuestion[7].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[7].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[7].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[7].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i].relevanceRemarksCRC,

                institutionName: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].relevanceRemarksCRC,

                status: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].response,
                statusRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].relevanceResponseCRC,
                statusRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].relevanceRemarksCRC,

                date: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].response,
                dateRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].relevanceRemarksCRC,

                peakBalance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].response,
                peakBalanceRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].relevanceResponseCRC,
                peakBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr7.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            status: '',
            statusRelevance: '',
            statusRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            peakBalance: '',
            peakBalanceRelevance: '',
            peakBalanceRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',
        };
        clientArr7.push(clientArr);
    }
    initialValues.client7 = clientArr7;

    const clientArr8 = [];
    // Screen 7 - Accordion 8

    if (checklist1que && checklist1que[6].subQuestion[8].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[8].fields.length; i += 10) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[8].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[8].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i].relevanceRemarksCRC,

                institutionName: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].relevanceRemarksCRC,

                status: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].response,
                statusRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].relevanceResponseCRC,
                statusRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].relevanceRemarksCRC,

                date: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].response,
                dateRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].relevanceRemarksCRC,

                peakBalance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].response,
                peakBalanceRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].relevanceResponseCRC,
                peakBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].relevanceRemarksCRC,

                grossAmount: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].response,
                grossAmountRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].relevanceResponseCRC,
                grossAmountRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].relevanceRemarksCRC,
            };
            clientArr8.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            status: '',
            statusRelevance: '',
            statusRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            peakBalance: '',
            peakBalanceRelevance: '',
            peakBalanceRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',

            grossAmount: '',
            grossAmountRelevance: '',
            grossAmountRelevanceRemarks: '',
        };
        clientArr8.push(clientArr);
    }
    initialValues.client8 = clientArr8;

    const clientArr9 = [];
    // Screen 7 - Accordion 9
    if (checklist1que && checklist1que[6].subQuestion[9].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[9].fields.length; i += 10) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[9].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[9].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i].relevanceRemarksCRC,

                entityName: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].response,
                entityNameRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].relevanceResponseCRC,
                entityNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].relevanceRemarksCRC,

                entityAddress: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].response,
                entityAddressRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].relevanceResponseCRC,
                entityAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].relevanceRemarksCRC,

                entityNature: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].response,
                entityNatureRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].relevanceResponseCRC,
                entityNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].relevanceRemarksCRC,

                acquireDate: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].response,
                acquireDateRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].relevanceResponseCRC,
                acquireDateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].relevanceRemarksCRC,

                initialInvest: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].response,
                initialInvestRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].relevanceResponseCRC,
                initialInvestRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].relevanceRemarksCRC,

                peakInvest: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].response,
                peakInvestRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].relevanceResponseCRC,
                peakInvestRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].relevanceRemarksCRC,

                grossAmount: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].response,
                grossAmountRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].relevanceResponseCRC,
                grossAmountRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].relevanceRemarksCRC,
            };
            clientArr9.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            entityName: '',
            entityNameRelevance: '',
            entityNameRelevanceRemarks: '',

            entityAddress: '',
            entityAddressRelevance: '',
            entityAddressRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            entityNature: '',
            entityNatureRelevance: '',
            entityNatureRelevanceRemarks: '',

            acquireDate: '',
            acquireDateRelevance: '',
            acquireDateRelevanceRemarks: '',

            initialInvest: '',
            initialInvestRelevance: '',
            initialInvestRelevanceRemarks: '',

            peakInvest: '',
            peakInvestRelevance: '',
            peakInvestRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',

            grossAmount: '',
            grossAmountRelevance: '',
            grossAmountRelevanceRemarks: '',
        };
        clientArr9.push(clientArr);
    }
    initialValues.client9 = clientArr9;

    const clientArr10 = [];
    // Screen 7 - Accordion 10
    if (checklist1que && checklist1que[6].subQuestion[10].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[10].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que[6].subQuestion[10].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[10].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[10].fields[i].relevanceRemarksCRC,

                instiName: checklist1que[6].subQuestion[10].fields[i + 1].response,
                instiNameRelevance: checklist1que[6].subQuestion[10].fields[i + 1].relevanceResponseCRC,
                instiNameRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 1].relevanceRemarksCRC,

                instiAddr: checklist1que[6].subQuestion[10].fields[i + 2].response,
                instiAddrRelevance: checklist1que[6].subQuestion[10].fields[i + 2].relevanceResponseCRC,
                instiAddrRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que[6].subQuestion[10].fields[i + 3].response,
                zipRelevance: checklist1que[6].subQuestion[10].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 3].relevanceRemarksCRC,

                date: checklist1que[6].subQuestion[10].fields[i + 4].response,
                dateRelevance: checklist1que[6].subQuestion[10].fields[i + 4].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 4].relevanceRemarksCRC,

                cashValue: checklist1que[6].subQuestion[10].fields[i + 5].response,
                cashValueRelevance: checklist1que[6].subQuestion[10].fields[i + 5].relevanceResponseCRC,
                cashValueRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 5].relevanceRemarksCRC,

                grossValue: checklist1que[6].subQuestion[10].fields[i + 6].response,
                grossValueRelevance: checklist1que[6].subQuestion[10].fields[i + 6].relevanceResponseCRC,
                grossValueRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr10.push(clientArr);
        }
    } else {
        const clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            instiName: '',
            instiNameRelevance: '',
            instiNameRelevanceRemarks: '',

            instiAddr: '',
            instiAddrRelevance: '',
            instiAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            cashValue: '',
            cashValueRelevance: '',
            cashValueRelevanceRemarks: '',

            grossValue: '',
            grossValueRelevance: '',
            grossValueRelevanceRemarks: '',
        };
        clientArr10.push(clientArr);
    }
    initialValues.client10 = clientArr10;

    const labelAdataArr = [];
    // Screen 8 - Lable A
    if (checklist1que && checklist1que[7].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[0].fields.length; i += 3) {
            const labelAdataArr1 = {
                description: checklist1que && checklist1que[7].subQuestion[0].fields[i].response,
                descriptionRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i].relevanceResponseCRC,
                descriptionRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i].relevanceRemarksCRC,

                address: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].response,
                addressRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                addressRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].relevanceRemarksCRC,

                amount: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].response,
                amountRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].relevanceResponseCRC,
                amountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].relevanceRemarksCRC,
            };
            labelAdataArr.push(labelAdataArr1);
        }
    } else {
        const labelAdataArr1 = {
            description: '',
            descriptionRelevance: '',
            descriptionRelevanceRemarks: '',
            address: '',
            addressRelevance: '',
            addressRelevanceRemarks: '',
            amount: '',
            amountRelevance: '',
            amountRelevanceRemarks: '',
        };
        labelAdataArr.push(labelAdataArr1);
    }
    initialValues.labelAdata = labelAdataArr;

    const labelBdataArr = [];
    // Screen 8 - Label B
    if (checklist1que && checklist1que[7].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[1].fields.length; i += 8) {
            let labelBdataArr1 = {
                jewellaryBullions: (checklist1que && checklist1que[7].subQuestion[1].fields[i].response) || '',
                jewellaryBullionsRelevance: (checklist1que && checklist1que[7].subQuestion[1].fields[i].relevanceResponseCRC) || '',
                jewellaryBullionsRelevanceRemarks: (checklist1que && checklist1que[7].subQuestion[1].fields[i].relevanceRemarksCRC) || '',

                archaeologicalCollections: (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].response) || '',
                archaeologicalCollectionsRelevance:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].relevanceResponseCRC) || '',
                archaeologicalCollectionsRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].relevanceRemarksCRC) || '',

                vehiclesYatchBoatsAircrafts: (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].response) || '',
                vehiclesYatchBoatsAircraftsRelevance:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].relevanceResponseCRC) || '',
                vehiclesYatchBoatsAircraftsRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].relevanceRemarksCRC) || '',

                faAAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].response,
                faAAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                faAAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                faBAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].response,
                faBAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                faBAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                faCAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].response,
                faCAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                faCAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                faDAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].response,
                faDAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                faDAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                faEAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].response,
                faEAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                faEAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].relevanceRemarksCRC,
            };
            labelBdataArr.push(labelBdataArr1);
        }
    } else {
        let labelBdataArr1 = {
            jewellaryBullions: '',
            jewellaryBullionsRelevance: '',
            jewellaryBullionsRelevanceRemarks: '',
            archaeologicalCollections: '',
            archaeologicalCollectionsRelevance: '',
            archaeologicalCollectionsRelevanceRemarks: '',
            vehiclesYatchBoatsAircrafts: '',
            vehiclesYatchBoatsAircraftsRelevance: '',
            vehiclesYatchBoatsAircraftsRelevanceRemarks: '',
            faAAmount: '',
            faAAmountRelevance: '',
            faAAmountRelevanceRemarks: '',
            faBAmount: '',
            faBAmountRelevance: '',
            faBAmountRelevanceRemarks: '',
            faCAmount: '',
            faCAmountRelevance: '',
            faCAmountRelevanceRemarks: '',
            faDAmount: '',
            faDAmountRelevance: '',
            faDAmountRelevanceRemarks: '',
            faEAmount: '',
            faEAmountRelevance: '',
            faEAmountRelevanceRemarks: '',
        };
        labelBdataArr.push(labelBdataArr1);
    }
    initialValues.labelBdata = labelBdataArr;

    let labelCdataArr = [];
    // Screen 8 - Label C
    if (checklist1que && checklist1que[7].subQuestion[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[2].fields.length; i += 16) {
            let labelCdataArr1 = {
                name: checklist1que && checklist1que[7].subQuestion[2].fields[i].response,
                nameCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i].relevanceResponseCRC,
                nameCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].response,
                panCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].relevanceResponseCRC,
                panCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].relevanceRemarksCRC,

                particularShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].response,
                particularShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].relevanceResponseCRC,
                particularShareCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].relevanceRemarksCRC,

                particularCost: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].response,
                particularCostCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].relevanceResponseCRC,
                particularCostCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].relevanceRemarksCRC,

                acquiredShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].response,
                acquiredShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].relevanceResponseCRC,
                acquiredShareCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].relevanceRemarksCRC,

                acquiredDate: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].response,
                acquiredDateCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].relevanceResponseCRC,
                acquiredDateCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].relevanceRemarksCRC,

                acquiredValue: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].response,
                acquiredValueCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].relevanceResponseCRC,
                acquiredValueCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].relevanceRemarksCRC,

                acquiredIssuePrice: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].response,
                acquiredIPCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].relevanceResponseCRC,
                acquiredIPCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].relevanceRemarksCRC,

                acquiredPurchasePrice: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].response,
                acquiredPPCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].relevanceResponseCRC,
                acquiredPPCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].relevanceRemarksCRC,

                transferredShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].response,
                tsCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].relevanceResponseCRC,
                tsCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].relevanceRemarksCRC,

                transferredSale: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].response,
                tsaleCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].relevanceResponseCRC,
                tsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].relevanceRemarksCRC,

                closingShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].response,
                closingShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].relevanceResponseCRC,
                closingSharetsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].relevanceRemarksCRC,

                closingCost: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].response,
                closingCostCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].relevanceResponseCRC,
                closingCostsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].relevanceRemarksCRC,

                closingSale: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].response,
                closingSaleCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].relevanceResponseCRC,
                closingSaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].relevanceRemarksCRC,

                noOfShare: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].response) || '',
                noOfShareCRelevance: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].relevanceResponseCRC) || '',
                noOfShareCRelevanceRemarks: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].relevanceRemarksCRC) || '',

                costOfAcquisition: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].response) || '',
                costOfAcquisitionCRelevance: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].relevanceResponseCRC) || '',
                costOfAcquisitionCRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].relevanceRemarksCRC) || '',
            };
            labelCdataArr.push(labelCdataArr1);
        }
    } else {
        let labelCdataArr1 = {
            name: '',
            nameCRelevance: '',
            nameCRelevanceRemarks: '',

            pan: '',
            panCRelevance: '',
            panCRelevanceRemarks: '',

            particularShare: '',
            particularShareCRelevance: '',
            particularShareCRelevanceRemarks: '',

            particularCost: '',
            particularCostCRelevance: '',
            particularCostCRelevanceRemarks: '',

            acquiredShare: '',
            acquiredShareCRelevance: '',
            acquiredShareCRelevanceRemarks: '',

            acquiredDate: '',
            acquiredDateCRelevance: '',
            acquiredDateCRelevanceRemarks: '',

            acquiredValue: '',
            acquiredValueCRelevance: '',
            acquiredValueCRelevanceRemarks: '',

            acquiredIssuePrice: '',
            acquiredIPCRelevance: '',
            acquiredIPCRelevanceRemarks: '',

            acquiredPurchasePrice: '',
            acquiredPPCRelevance: '',
            acquiredPPCRelevanceRemarks: '',

            transferredShare: '',
            tsCRelevance: '',
            tsCRelevanceRemarks: '',

            transferredSale: '',
            tsaleCRelevance: '',
            tsaleCRelevanceRemarks: '',

            closingShare: '',
            closingShareCRelevance: '',
            closingSharetsaleCRelevanceRemarks: '',

            closingCost: '',
            closingCostCRelevance: '',
            closingCostsaleCRelevanceRemarks: '',

            closingSale: '',
            closingSaleCRelevance: '',
            closingSaleCRelevanceRemarks: '',

            noOfShare: '',
            noOfShareCRelevance: '',
            noOfShareCRelevanceRemarks: '',

            costOfAcquisition: '',
            costOfAcquisitionCRelevance: '',
            costOfAcquisitionCRelevanceRemarks: '',
        };
        labelCdataArr.push(labelCdataArr1);
    }
    initialValues.labelCdata = labelCdataArr;

    let labelDdataArr = [];
    // Screen 8 - Label D

    if (checklist1que && checklist1que[7].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[3].fields.length; i += 3) {
            let labelDdataArr1 = {
                name: checklist1que && checklist1que[7].subQuestion[3].fields[i].response,
                nameDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i].relevanceResponseCRC,
                nameDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].response,
                panDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].relevanceResponseCRC,
                panDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].relevanceRemarksCRC,

                value: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].response,
                valueDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].relevanceResponseCRC,
                valueDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].relevanceRemarksCRC,
            };
            labelDdataArr.push(labelDdataArr1);
        }
    } else {
        let labelDdataArr1 = {
            name: '',
            nameDRelevance: '',
            nameDRelevanceRemarks: '',

            pan: '',
            panDRelevance: '',
            panDRelevanceRemarks: '',

            value: '',
            valueDRelevance: '',
            valueDRelevanceRemarks: '',
        };
        labelDdataArr.push(labelDdataArr1);
    }

    initialValues.labelDdata = labelDdataArr;

    let labelEdataArr = [];
    // Screen 8 - Label E
    if (checklist1que && checklist1que[7].subQuestion[4].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[4].fields.length; i += 2) {
            let labelEdataArr1 = {
                particular: checklist1que && checklist1que[7].subQuestion[4].fields[i].response,
                particularRelevance: checklist1que && checklist1que[7].subQuestion[4].fields[i].relevanceResponseCRC,
                particularRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[4].fields[i].relevanceRemarksCRC,

                amount: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].response,
                amountERelevance: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].relevanceResponseCRC,
                amountERelevanceRemarks: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].relevanceRemarksCRC,
            };
            labelEdataArr.push(labelEdataArr1);
        }
    } else {
        let labelEdataArr1 = {
            particular: '',
            particularRelevance: '',
            particularRelevanceRemarks: '',

            amount: '',
            amountERelevance: '',
            amountERelevanceRemarks: '',
        };
        labelEdataArr.push(labelEdataArr1);
    }
    initialValues.labelEdata = labelEdataArr;

    const addremarks = [];
    const addremarksL2Checklist = [];

    if (checklist && checklist.additionalQuestion && checklist.additionalQuestion !== null)
        for (let i = 0; i < checklist.additionalQuestion.length; i++) {
            const additionalQuestionData = {
                questionId: checklist.additionalQuestion[i].questionId || '',

                questionText: checklist.additionalQuestion[i].questionText || '',
                response:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].response
                        : '',
                relevanceResponseCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceResponseCRC
                        : '',
                relevanceRemarksCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceRemarksCRC
                        : '',
            };
            addremarks.push(additionalQuestionData);
        }

    if (checklist1que && checklist1que[8].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[8].subQuestion[0].fields.length; i++) {
            const additionalQuestionData = {
                questionId:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceRemarksAM
                        : '',

                questionText:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceResponseAM
                        : '',
                response:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].response
                        : '',
                relevanceResponseCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceResponseCRC
                        : '',
                relevanceRemarksCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceRemarksCRC
                        : '',
            };
            addremarksL2Checklist.push(additionalQuestionData);
        }
    }

    initialValues.remarks = statusIDValue === 2 ? addremarks : addremarksL2Checklist;

    const investmentArr1 = [];

    if (checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields.length > 0) {
        //console.log("ravi......", checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0]);
        for (let i = 0; i < checklist1que[2].subQuestion[6].subSubQuestions[0].fields.length; i += 3) {
            let investmentArrtemp = {
                investmentDetails: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].response,
                investmentDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceResponseCRC,
                investmentDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                investmentAmt: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].response,
                investmentAmtCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                investmentAmtCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,
                invAmtUpload: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 2].response,
            };
            investmentArr1.push(investmentArrtemp);
        }
    } else {
        const investmentArrtemp = {
            investmentDetails: '',
            investmentAmt: '',
            invAmtUpload: '',
        };
        investmentArr1.push(investmentArrtemp);
    }
    initialValues.investment1 = investmentArr1;

    //console.log("investment1", initialValues.investment1);

    const donationArr1 = [];

    if (checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[6].subSubQuestions[1].fields.length; i += 3) {
            const donationArrtemp = {
                donationDetails: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].response,
                donationDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceResponseCRC,
                donationDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                donationAmt: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].response,
                donationAmountCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                donationAmountCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                donationAmtUpload: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 2].response,
            };
            donationArr1.push(donationArrtemp);
        }
    } else {
        const donationArrtemp = {
            donationDetails: '',
            donationAmt: '',
            donationAmtUpload: '',
        };
        donationArr1.push(donationArrtemp);
    }
    initialValues.donation1 = donationArr1;

    const validationSchema = Yup.object().shape({
        firstName: clientType === 'CORPORATE' ? '' : Yup.string().nullable().label('FirstName').required('Required Field'),
        lastName: Yup.string().nullable().label('LastName').required('Required Field'),
        fatherNamePan: clientType === 'CORPORATE' ? '' : Yup.string().nullable().label('FathersName').required('Required Field'),
        address1: Yup.string().nullable().required('Please Enter your Address'),
        address2: Yup.string().nullable().required('Please Enter your Address'),
        city: Yup.string()
            .nullable()
            .matches(/^[aA-zZ ]+$/, 'Enter a Valid City')
            .required('Required Field'),
        state: Yup.string().ensure().required('State Required Field'),
        country: Yup.string()
            .nullable()
            .matches(/^[aA-zZ ]+$/, 'Enter a Valid Country')
            .required('Required Field'),
        pin: Yup.string()
            .nullable()
            .matches(/^\d{4,6}$/, 'Enter a valid PIN')
            .required('Please enter your PinCode'),

        dob:
            clientType === 'CORPORATE'
                ? ''
                : Yup.date()
                      .nullable()
                      .required('Please Enter your Date Of Birth')
                      .max(new Date(), 'Date of Birth should not be a future date'),
        // .test('dob', 'You must be 18 or older', (dobValue) => {
        //     const cutOff = new Date();
        //     cutOff.setFullYear(cutOff.getFullYear() - 18);
        //     return dobValue <= cutOff;
        // }),
        mobileNo: Yup.string()
            .nullable()
            // .matches(/^[0-9]{10,12}$/, 'Enter vaild mobile number')
            // .matches(/^\+[1-9]{1}[0-9]{7,11}$/, 'Enter vaild mobile number with valid Country code')
            .matches(/^\+[1-9]{1}[0-9]{7,11}$/, 'Enter vaild mobile number with valid Country code')
            .required('Mobile number is Mandatory'),
        emailaddress: Yup.string()
            .nullable()
            .matches(/^[a-zA-Z0-9._-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}$/, 'Enter Valid Email')
            .email('Invalid Email Format')
            .required('Required Field'),
        passport:
            clientType === 'CORPORATE'
                ? ''
                : Yup.string()
                      .nullable()
                      .matches(/^[A-Za-z0-9]+$/, 'Enter valid Passport Number'),
        // .required('Passport is Required'),
        pan: Yup.string()
            .nullable()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Enter Valid PAN')
            .required('PAN is Mandatory'),
        govIDType: Yup.string(),
        govIDNumber:
            clientType === 'CORPORATE'
                ? ''
                : Yup.string()
                      .nullable()
                      .when('govIDType', {
                          is: 'aadharNo' || 'enrollmentNo',
                          then: Yup.string()
                              .matches(/^\d{4}\d{4}\d{4}$/, 'Enter Valid 12 digit Aadhaar Number')
                              .required('Aadhaar Number is Mandatory'),
                      }),
        radiodata: Yup.string(),
        GSTIN: Yup.string()
            .nullable()
            .when('radiodata', {
                is: 'Yes',
                then: Yup.string()
                    .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[zZ]{1}[0-9A-Z]{1}$/, 'Enter Valid GSTIN')
                    .required('GSTIN is Mandatory'),
            }),
    });

    const isFileUpload = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setIsDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e., xlsx/xls/csv');
                setIsDisable(true);
            }
        }
    };

    const fileUpload = () => {
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(
                `${CommonConfig.dev.baseUrl}/api/auth/s3upload/${
                    usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                }/${serviceIdValue}/myimage`,
                data,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((response) => {
                if (response.data) {
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    setURLValue(response.data);
                    setAttachedFileAadhar(filename);
                    setUploadSuccessfully('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClose();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisable(true);
                }
            });
    };
    const handleCloseNew = () => {
        setHandleOpenNew(false);
        setIsfileInvalidNew('');
        setUploadSuccessfullyNew('');
    };
    const handleClickNew = () => {
        setHandleOpenNew(true);
        setClearDataNew('');
        setFilenameNew('');
        setIsDisableNew(true);
    };
    const isFileUploadNew = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameNew(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidNew('');
                setIsDisableNew(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidNew('Please select the file size less than 10MB');
                    setIsDisableNew(true);
                } else {
                    setSelectedFileDataNew(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidNew('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableNew(true);
            }
        }
    };

    const fileUploadNew = () => {
        const data = new FormData();

        data.append('file', selectedFileDataNew);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/${serviceIdValue}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    const filename = response.data.substring(response.data.lastIndexOf('/') + 1);
                    setURLValue(response.data);
                    setAttachedFileEnrollment(filename);
                    setUploadSuccessfullyNew('Uploaded a file successfully');
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableNew(true);
                }
            });
    };

    const previewImage = () => {
        if (!selectedFileData) {
            setPreview(undefined);
            return;
        }
        const objectUrl = URL.createObjectURL(selectedFileData);
        setPreview(objectUrl);
        {
            return selectedFileData && <img src={preview} alt="Preview" />;
        }
    };

    const handleSubmit = (values) => {
        if (statusIDValue === 2) {
            let tempObj = {};
            files.filter((ele, i) => {
                if (ele.filePath) {
                    tempObj = {
                        questionId: '',
                        questionText: 'uploadFile',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        response: ele.filePath,
                    };
                }
                if (!ele.filePath) {
                    tempObj = {
                        questionId: '',
                        questionText: 'uploadFile',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        response: '',
                    };
                }
                values.remarks.push(tempObj);
            });
        }

        setShowLoaderSubmit(true);
        const data = {
            // Screen 2
            bankDetails: values.bankDetails,
            // screen 3 - Tab 1 - Salary
            nameEmployer: values.nameEmployer,
            nameEmployerCRCrelevenceResponse:
                checklist1 && checklist1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceResponseCRC,
            nameEmployerCRCrelevenceRemarks:
                checklist1 && checklist1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceRemarksCRC,
            url: checklist1 && checklist1.questions[2].subQuestion[0].subSubQuestions[0].fields[2].response,
            salaryradiodata: values.salaryradiodata,
            investment: values.investment,
            donation: values.donation,
            // screen 3 - Tab 2 - House prop
            houseproperty: values.houseproperty,
            incomeFromHouseProperty: values.incomeFromHouseProperty,
            // screen 3 - Tab 3 - Business
            incomeFromBusinessProfesion: values.incomeFromBusinessProfesion,

            natureBusiness: values.natureBusiness,
            natureBusinessCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceResponseCRC,
            natureBusinessCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceRemarksCRC,

            busProfincomeType: values.busProfincomeType,
            busProfincomeTypeCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceResponseCRC,
            busProfincomeTypeCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceRemarksCRC,

            totalReceipts: values.totalReceipts,
            totalReceiptsCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceResponseCRC,
            totalReceiptsCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceRemarksCRC,

            totalExpenses: values.totalExpenses,
            totalExpensesCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceResponseCRC,
            totalExpensesCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceRemarksCRC,

            gstReturnDoc: values.gstReturnDoc,
            gstReturnDocCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceResponseCRC,
            gstReturnDocCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceRemarksCRC,

            otherStatement: values.otherStatement,
            otherStatementCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceResponseCRC,
            otherStatementCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceRemarksCRC,

            busProfType: values.busProfType,
            busProfTypeCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceResponseCRC,
            busProfTypeCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceRemarksCRC,

            userIDtally: values.userIDtally,
            userIDtallyCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceResponseCRC,
            userIDtallyCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceRemarksCRC,

            passwordtally: values.passwordtally,
            passwordtallyCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceResponseCRC,
            passwordtallyCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceRemarksCRC,

            uploadTally: values.uploadTally,
            uploadTallyCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceResponseCRC,
            uploadTallyCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceRemarksCRC,

            userIDZoho: values.userIDZoho,
            userIDZohoCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceResponseCRC,
            userIDZohoCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceRemarksCRC,

            passwordZoho: values.passwordZoho,
            passwordZohoCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceResponseCRC,
            passwordZohoCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceRemarksCRC,

            userIDQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].response,
            userIDQBCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceResponseCRC,
            userIDQBCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceRemarksCRC,

            passwordQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].response,
            passwordQBCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceResponseCRC,
            passwordQBCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceRemarksCRC,

            accountDetails: values.accountDetails,
            accountDetailsCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceResponseCRC,
            accountDetailsCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceRemarksCRC,

            partnershipradio: values.partnershipradio,
            partnershipradioCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceResponseCRC,
            partnershipradioCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceRemarksCRC,

            tallyYes: values.tallyYes,
            totalReceiptsUpload: values.totalReceiptsUpload,
            totalExpensesUpload: values.totalExpensesUpload,
            gstUpload: values.gstUpload,
            statementUpload: values.statementUpload,

            // screen 3 - Tab 4 -capitl gain
            capitalgain: values.capitalgain,
            soldAnyAsset: values.soldAnyAsset,
            // screen 3 -Tab 5 - other sources
            divident: values.divident,
            fd: values.fd,
            othersources: values.othersources,
            explicitlyUncoveredIncom: values.explicitlyUncoveredIncom,
            // screen 3 - Tab 6 - Agri
            agricultureIncome: values.agricultureIncome,
            agriculture: values.agriculture,
            // agricultureName: values.agricultureName,
            // agriAmount: values.agriAmount,
            // agriReceipt: values.agriReceipt,
            // agriExpenses: values.agriExpenses,
            // agriExpensesUpload: values.agriExpensesUpload,
            // agriReceiptUpload: values.agriReceiptUpload,

            // Scren 4 Income Tax
            incomeTaxType: checklist1 && checklist1.questions[3].fields[0].response,
            incomeUserId: checklist1 && checklist1.questions[3].fields[1].response,
            userIdRelevance: checklist1 && checklist1.questions[3].fields[1].relevanceResponseCRC,
            userIdRelevanceRemarks: checklist1 && checklist1.questions[3].fields[1].relevanceRemarksCRC,
            incomePassword: checklist1 && checklist1.questions[3].fields[2].response,
            passwordRelevance: checklist1 && checklist1.questions[3].fields[2].relevanceResponseCRC,
            passwordRelevanceRemarks: checklist1 && checklist1.questions[3].fields[2].relevanceRemarksCRC,

            // Screen 5
            traveloutsideType: values.traveloutsideType,
            travelOutside: values.travelOutside,
            // Screen 6
            directorType: values.directorType,
            directorCompany: values.directorCompany,

            // Screen 7
            assetradio: values.assetradio,

            client10: values.client10,
            client9: values.client9,
            client8: values.client8,
            client7: values.client7,
            client6: values.client6,
            client5: values.client5,
            client4: values.client4,
            client3: values.client3,
            client2: values.client2,
            client1: values.client1,
            assetHome: values.assetHome,
            assetNature: values.assetNature,
            // Screen 8
            // totalIncome
            totalincomeradio: values.totalincomeradio,
            labelEdata: values.labelEdata,
            labelDdata: values.labelDdata,
            labelCdata: values.labelCdata,
            labelBdata: values.labelBdata,
            labelAdata: values.labelAdata,

            firstName: values.firstName,
            firstnameRelevance: (checklist1 && checklist1.questions[0].fields[0].relevanceResponseCRC) || '',
            firstnameRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[0].relevanceRemarksCRC) || '',

            lastName: values.lastName,
            lastnameRelevance: (checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC) || '',
            lastnameRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[1].relevanceRemarksCRC) || '',

            fatherNamePan: values.fatherNamePan,
            fatherNamePanRelevance: (checklist1 && checklist1.questions[0].fields[2].relevanceResponseCRC) || '',
            fatherNamePanRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[2].relevanceRemarksCRC) || '',

            pan: values.pan,
            panRelevance: (checklist1 && checklist1.questions[0].fields[3].relevanceResponseCRC) || '',
            panRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[3].relevanceRemarksCRC) || '',

            address1: values.address1,
            address1Relevance: (checklist1 && checklist1.questions[0].fields[4].relevanceResponseCRC) || '',
            address1RelevanceRemarks: (checklist1 && checklist1.questions[0].fields[4].relevanceRemarksCRC) || '',

            address2: values.address2,
            address2Relevance: (checklist1 && checklist1.questions[0].fields[5].relevanceResponseCRC) || '',
            address2RelevanceRemarks: (checklist1 && checklist1.questions[0].fields[5].relevanceRemarksCRC) || '',

            city: values.city,
            cityRelevance: (checklist1 && checklist1.questions[0].fields[6].relevanceResponseCRC) || '',
            cityRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[6].relevanceRemarksCRC) || '',

            state: values.state,
            stateRelevance: (checklist1 && checklist1.questions[0].fields[7].relevanceResponseCRC) || '',
            stateRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[7].relevanceRemarksCRC) || '',

            country: values.country,
            countryRelevance: (checklist1 && checklist1.questions[0].fields[8].relevanceResponseCRC) || '',
            countryRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[8].relevanceRemarksCRC) || '',

            pin: values.pin,
            pinRelevance: (checklist1 && checklist1.questions[0].fields[9].relevanceResponseCRC) || '',
            pinRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[9].relevanceRemarksCRC) || '',

            dob: values.dob,
            dobRelevance: (checklist1 && checklist1.questions[0].fields[10].relevanceResponseCRC) || '',
            dobRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[10].relevanceRemarksCRC) || '',

            mobileNo: values.mobileNo,
            mobileNoRelevance: (checklist1 && checklist1.questions[0].fields[11].relevanceResponseCRC) || '',
            mobileNoRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[11].relevanceRemarksCRC) || '',

            emailaddress: values.emailaddress,
            emailaddressRelevance: (checklist1 && checklist1.questions[0].fields[12].relevanceResponseCRC) || '',
            emailaddressRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[12].relevanceRemarksCRC) || '',

            passport: values.passport,
            passportRelevance: (checklist1 && checklist1.questions[0].fields[13].relevanceResponseCRC) || '',
            passportRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[13].relevanceRemarksCRC) || '',

            govIDType: values.govIDType,

            govIDNumber: values.govIDType !== 'notEnrolled' ? values.govIDNumber : '',
            govIDNumberRelevance: (checklist1 && checklist1.questions[0].fields[15].relevanceResponseCRC) || '',
            govIDNumberRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[15].relevanceRemarksCRC) || '',

            URLValue: values.URLValue,
            panFile: URLValuePan ? URLValuePan : '',
            aadharFile: URLValue ? URLValue : '',
            enrollmentFile: '',
            gstFile: URLValueGstin ? URLValueGstin : '',

            radiodata: values.radiodata,

            GSTIN: values.GSTIN,
            gstinRelevance: (checklist1 && checklist1.questions[0].fields[18].relevanceResponseCRC) || '',
            gstinRelevanceRemarks: (checklist1 && checklist1.questions[0].fields[18].relevanceRemarksCRC) || '',

            additionalQue:
                statusIDValue === 2
                    ? checklist && checklist.additionalQuestion != null
                        ? values.remarks
                        : null
                    : checklist1que && checklist1que[8].subQuestion[0].fields != null
                    ? values.remarks
                    : null,

            investment1: values.investment1,
            donation1: values.donation1,
        };
        // console.log('onSubmit.....values', data);

        // dispatch(createGenInfoRequest({ params: data }));
        setShowLoader(true);

        dispatch(createGenInfoRequestSave({ params: data, bearerToken, serviceIdValue, usertype, tennantnameValue }));
        setShowLoaderSubmit(false);
        setTimeout(() => {
            setShowLoader(false);
            props.handlePageChange(2);
        }, 4000);
    };

    const toInputUppercase = (e) => {
        e.target.value = e.target.value.toUpperCase();
    };

    const handleClosePan = () => {
        setHandleOpenPan(false);
        setIsfileInvalidPan('');
        setUploadSuccessfullyPan('');
    };
    const handleClickPan = () => {
        setHandleOpenPan(true);
        setClearDataPan('');
        setFilenamePan('');
        setIsDisablePan(true);
    };
    const isFileUploadPan = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf)$');
            setFilenamePan(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidPan('');
                setIsDisablePan(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidPan('Please select the file size less than 10MB');
                    setIsDisablePan(true);
                } else {
                    setSelectedFileDataPan(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidPan('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisablePan(true);
            }
        }
    };

    const fileUploadPan = () => {
        const data = new FormData();
        data.append('file', selectedFileDataPan);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/${serviceIdValue}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                // console.log('responseFormat', response);
                if (response.data) {
                    setURLValuePan(response.data);
                    // setPathExtension(response.data.match(/\.(jpeg|jpg|gif|png|pdf)$/) !== null);
                    // {
                    //     URLValuePan.split('.').pop() === 'zip' ? 'Chandra' : 'Ravi';
                    // }
                    setAttachedFilePan(response.data.substring(response.data.lastIndexOf('/') + 1));
                    setUploadSuccessfullyPan('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClosePan();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisablePan(true);
                }
            });
    };

    const handleCloseGstin = () => {
        setHandleOpenGstin(false);
        setIsfileInvalidGstin('');
        setUploadSuccessfullyGstin('');
    };
    const handleClickGstin = () => {
        setHandleOpenGstin(true);
        setClearDataGstin('');
        setFilenameGstin('');
        setIsDisableGstin(true);
    };
    const isFileUploadGstin = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenameGstin(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidGstin('');
                setIsDisableGstin(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidGstin('Please select the file size less than 10MB');
                    setIsDisableGstin(true);
                } else {
                    setSelectedFileDataGstin(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidGstin('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisableGstin(true);
            }
        }
    };
    const fileUploadGstin = () => {
        const data = new FormData();
        data.append('file', selectedFileDataGstin);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${dbname}/${serviceIdValue}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValueGstin(response.data);
                    setAttachedFileGSTIN(response.data.substring(response.data.lastIndexOf('/') + 1));
                    setUploadSuccessfullyGstin('Uploaded a file successfully');
                    setTimeout(() => {
                        handleCloseGstin();
                    }, 500);
                }
            })
            .catch((error) => {
                if (error.response.data) {
                    setIsDisableGstin(true);
                }
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };
    // const downloadCoreFile = (file) => {
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //             responseType: 'blob',
    //         })

    //         .then((response) => {
    //             const link = document.createElement('a');
    //             link.href = response.config.url;
    //             link.setAttribute('download', response.config.url);
    //             link.click();
    //         });
    // };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
            >
                {(formik) => {
                    const { govIDType, radiodata } = formik.values;
                    return (
                        <Card className="client-card">
                            <CardContent className="client-heading">
                                <Typography variant="h5">General Information</Typography>
                                {statusIDValue === 2 ? (
                                    <div className={classes.noteView}>
                                        * Some of the fields are autofilled. Please confirm the same and if you wish to edit, you can please
                                        do so. This update is only for ITR and not for the profile
                                    </div>
                                ) : null}
                            </CardContent>

                            <CardContent>
                                <form className="itecform" onSubmit={formik.handleSubmit}>
                                    {/* {checklistID !== null ? */}
                                    {/* {checklistID && checklistID.stageId !== 3 ? ( */}
                                    {
                                        checklist && checklist.currentStage && checklist.currentStage.id !== 2 ? (
                                            <span>
                                                <div style={{ marginLeft: '12px', display: 'flex', placeContent: 'flex-end' }}>
                                                    {relevanceList &&
                                                        relevanceList.map((user) => (
                                                            // <ul className={classes.relevenceDisplay}>
                                                            //     <li>
                                                            <span style={{ display: 'flex', marginLeft: '20px', alignItems: 'center' }}>
                                                                <div
                                                                    style={{ background: user.color, width: '16px', height: '15px' }}
                                                                ></div>
                                                                <div style={{ marginLeft: '6px' }}>{user.name}</div>
                                                            </span>
                                                            //     </li>
                                                            // </ul>
                                                        ))}
                                                </div>
                                            </span>
                                        ) : (
                                            ''
                                        )
                                        //     : <span>
                                        //         <div style={{ marginLeft: '12px', display: 'flex', placeContent: 'flex-end' }}>
                                        //             {relevanceList &&
                                        //                 relevanceList.map((user) => (
                                        //                     // <ul className={classes.relevenceDisplay}>
                                        //                     //     <li>
                                        //                     <span style={{ display: 'flex', marginLeft: '20px', alignItems: 'center' }}>
                                        //                         <div style={{ background: user.color, width: '16px', height: '15px' }}></div>
                                        //                         <div style={{ marginLeft: '6px' }}>{user.name}</div>
                                        //                     </span>
                                        //                     //     </li>
                                        //                     // </ul>
                                        //                 ))}
                                        //         </div>
                                        //     </span>
                                    }
                                    <Grid container spacing={3} className="main-container">
                                        {clientType === 'CORPORATE' ||
                                        (checklist1 && checklist1.questions[0].fields[0].response === 'NaN') ? (
                                            ''
                                        ) : (
                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="firstName" shrink>
                                                        {' '}
                                                        First Name <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </InputLabel>
                                                    <Input
                                                        autoComplete="off"
                                                        className={classes.bottomLine}
                                                        disabled={fieldDisable(
                                                            statusId,
                                                            checklist1 &&
                                                                checklist1.questions &&
                                                                checklist1.questions[0] &&
                                                                checklist1.questions[0].fields &&
                                                                checklist1.questions[0].fields[0].relevanceResponseCRC
                                                        )}
                                                        // }
                                                        // statusId === 6 &&
                                                        //     checklist1 &&
                                                        //     checklist1.questions[0].fields[0].relevanceResponseCRC === 'Relevant'
                                                        //     ? 'disabled'
                                                        //     : ''
                                                        id="firstName"
                                                        name="firstName"
                                                        placeholder="Enter First Name"
                                                        value={formik.values.firstName}
                                                        enableReinitialize={true}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    ></Input>
                                                    <div>
                                                        <Typography className={classes.bottomLine}>
                                                            {statusId === 6 &&
                                                                userType.value === 'L2 Checklist' &&
                                                                (checklist1 &&
                                                                checklist1.questions[0].fields[0].relevanceResponseCRC === 'Relevant' ? (
                                                                    <div className={classes.relevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[0].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[0].relevanceResponseCRC ===
                                                                      'Irrelavant' ? (
                                                                    <div className={classes.irrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[0].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[0].relevanceResponseCRC ===
                                                                      'Paritially Relevant' ? (
                                                                    <div className={classes.partrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[0].relevanceRemarksCRC}
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                ))}
                                                            {/* {statusId === 6 && userType.value === 'L2 Checklist' &&
                                                    checklist1 &&
                                                    checklist1.questions[0].fields[0].relevanceResponseCRC === 'Relevant' ? (
                                                        <div className={classes.relevanceIndicator}>
                                                            {checklist1 && checklist1.questions[0].fields[0].relevanceRemarksCRC}{' '}
                                                        </div>
                                                    ) : statusId === 6 &&
                                                      checklist1 &&
                                                      checklist1.questions[0].fields[0].relevanceResponseCRC === 'Irrelavant' ? (
                                                        <div className={classes.irrelevanceIndicator}>
                                                            {checklist1 && checklist1.questions[0].fields[0].relevanceRemarksCRC}{' '}
                                                        </div>
                                                    ) : statusId === 6 &&
                                                      checklist1 &&
                                                      checklist1.questions[0].fields[0].relevanceResponseCRC ===
                                                          'Paritially Relevant' ? (
                                                        <div className={classes.partrelevanceIndicator}>
                                                            {checklist1 && checklist1.questions[0].fields[0].relevanceRemarksCRC}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )} */}
                                                        </Typography>
                                                    </div>
                                                    {formik.touched.firstName && formik.errors.firstName ? (
                                                        <span className="validationError">{formik.errors.firstName}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                {clientType === 'CORPORATE' ||
                                                (checklist1 && checklist1.questions[0].fields[0].response === 'NaN') ? (
                                                    <InputLabel htmlFor="last-name" shrink>
                                                        Corporate Name <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </InputLabel>
                                                ) : (
                                                    <InputLabel htmlFor="last-name" shrink>
                                                        Last Name <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </InputLabel>
                                                )}
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[1].relevanceResponseCRC
                                                    )}
                                                    // statusId === 6 &&
                                                    //     checklist1 &&
                                                    //     checklist1.questions[0].fields[1].relevanceResponseCRC === 'Relevant'
                                                    //     ? 'disabled'
                                                    //     : ''
                                                    id="last-name"
                                                    name="lastName"
                                                    placeholder="Enter Last Name"
                                                    value={formik.values.lastName}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    // onChange={handleChange('amount')}
                                                />
                                                {/* <div style={{ color: 'red', border: 20 }}> */}
                                                {/* <div >
                                                <Typography className={classes.bottomLine}>
                                                    {statusId === 6 && userType.value === 'L2 Checklist' &&
                                                    
                                                    checklist1 && 
                                                    checklist1.questions[0].fields[1].relevanceResponseCRC === 'Relevant'
                                                    
                                                        ? 
                                                        <div className={classes.relevanceIndicator}>{
                                                        checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC
                                                        } </div>
                                                        : checklist1 && 
                                                          checklist1.questions[0].fields[1].relevanceResponseCRC === 'Irrelavant'
                                                        ? 
                                                        <div className={classes.irrelevanceIndicator}>{
                                                          checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC
                                                        } </div>
                                                        : checklist1 &&
                                                          checklist1.questions[0].fields[1].relevanceResponseCRC ===
                                                              'Paritially Relevant'
                                                        ? 
                                                        <div className={classes.irrelevanceIndicator}>{
                                                         checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC
                                                        }</div>
                                                        : '' }
                                                </Typography>
                                            </div> */}
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[1].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[1].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[1].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[1].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[1].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[1].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.lastName && formik.errors.lastName ? (
                                                    <span className="validationError">{formik.errors.lastName}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        {clientType === 'CORPORATE' ||
                                        (checklist1 && checklist1.questions[0].fields[0].response === 'NaN') ? (
                                            ''
                                        ) : (
                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="fathers-name" shrink>
                                                        Father's Name <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </InputLabel>
                                                    <Input
                                                        className={classes.bottomLine}
                                                        disabled={fieldDisable(
                                                            statusId,
                                                            checklist1 &&
                                                                checklist1.questions &&
                                                                checklist1.questions[0] &&
                                                                checklist1.questions[0].fields &&
                                                                checklist1.questions[0].fields[2].relevanceResponseCRC
                                                        )}
                                                        //     statusId === 6 &&
                                                        //         checklist1 &&
                                                        //         checklist1.questions[0].fields[2].relevanceResponseCRC === 'Relevant'
                                                        //         ? 'disabled'
                                                        //         : ''
                                                        // }
                                                        id="fathers-name"
                                                        name="fatherNamePan"
                                                        placeholder="Enter Father's Name"
                                                        value={formik.values.fatherNamePan}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        // onChange={handleChange('amount')}
                                                    />
                                                    {/* <div >
                                                <Typography className={classes.bottomLine}>
                                                    {statusId === 6 &&
                                                    checklist1 &&
                                                    checklist1.questions[0].fields[1].relevanceResponseCRC === 'Relevant'
                                                        ? checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC
                                                        : checklist1 &&
                                                          checklist1.questions[0].fields[1].relevanceResponseCRC === 'Irrelavant'
                                                        ? checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC
                                                        : checklist1 &&
                                                          checklist1.questions[0].fields[1].relevanceResponseCRC ===
                                                              'Paritially Relevant'
                                                        ? checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC
                                                        : ''}
                                                </Typography>
                                            </div> */}
                                                    <div>
                                                        <Typography className={classes.bottomLine}>
                                                            {statusId === 6 &&
                                                                userType.value === 'L2 Checklist' &&
                                                                (checklist1 &&
                                                                checklist1.questions[0].fields[2].relevanceResponseCRC === 'Relevant' ? (
                                                                    <div className={classes.relevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[2].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[2].relevanceResponseCRC ===
                                                                      'Irrelavant' ? (
                                                                    <div className={classes.irrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[2].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[2].relevanceResponseCRC ===
                                                                      'Paritially Relevant' ? (
                                                                    <div className={classes.partrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[2].relevanceRemarksCRC}
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                ))}
                                                        </Typography>
                                                    </div>

                                                    {formik.touched.fatherNamePan && formik.errors.fatherNamePan ? (
                                                        <span className="validationError">{formik.errors.fatherNamePan}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="pan" shrink>
                                                    PAN <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[3].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[3].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    id="pan"
                                                    name="pan"
                                                    placeholder="Enter PAN"
                                                    value={formik.values.pan}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    onInput={toInputUppercase}
                                                    // onChange={handleChange('amount')}
                                                />
                                                {/* <div className={classes.btnFieldPositionRight}>
                                                <Typography className={classes.bottomLine}>
                                                    {statusId === 6 && userType.value === 'L2 Checklist' &&
                                                    checklist1 &&
                                                    checklist1.questions[0].fields[3].relevanceResponseCRC === 'Relevant'
                                                        ? checklist1 && checklist1.questions[0].fields[3].relevanceResponseCRC
                                                        : ''}
                                                </Typography>
                                            </div> */}
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[3].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[3].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[3].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[3].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[3].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[3].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.pan && formik.errors.pan ? (
                                                    <span className="validationError">{formik.errors.pan}</span>
                                                ) : null}
                                                <div className={classes.btnFieldPositionRight}>
                                                    {attachedFilePan ? (
                                                        <span style={{ marginRight: '7px' }} className="fileName">
                                                            {attachedFilePan.substring(0, 15)}
                                                            {attachedFilePan.length > 15 ? '...' : ''}
                                                        </span>
                                                    ) : null}
                                                    {/* {URLValuePan.split('.').pop() === 'zip' ? 'Chandra' : 'Ravi'} */}
                                                    {/* {URLValuePan.match(/\.(jpeg|jpg|gif|png|pdf)$/) !== null 
                                                        ? 'chandra' : 'chandraRavi'} */}
                                                    {/* {pathExtension === true ? ( */}
                                                    {attachedFilePan ? (
                                                        <span onClick={() => handlePreviewModal(URLValuePan)}>
                                                            <Tooltip title="Preview">
                                                                <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                            </Tooltip>
                                                        </span>
                                                    ) : null}
                                                    {/* ) : ( */}
                                                    {/* <span onClick={() => downloadCoreFile(downloadPath)}>
                                                            <Tooltip title="Download">
                                                                <img
                                                                    src={downloadImage}
                                                                    alt="downloadImage"
                                                                    className="downlaodImg downloadImgTop"
                                                                />
                                                            </Tooltip>
                                                        </span> */}
                                                    {/* )} */}
                                                    {/* <span onClick={() => downloadCoreFile(index)}>
                                                                        <Tooltip title="Download">
                                                                            <img src={downloadImage} alt="downloadImage" className="downlaodImg" />
                                                                        </Tooltip>
                                                                    </span> */}
                                                    <span>
                                                        {/* {downloadPath.match(/\.(jpeg|jpg|gif|png)$/) !== null ?
                                                        <Viewer
                                                            visible={visible}
                                                            onClose={() => {
                                                                setVisible(false);
                                                            }}
                                                            images={[{ src: downloadPath, alt: ''}]}
                                                            noClose={false}
                                                            noFooter={true}
                                                            disableMouseZoom={true}
                                                            noLimitInitializationSize={true}
                                                            // defaultScale={2.5}
                                                            drag={false}
                                                            className="previewImg"
                                                        /> : */}
                                                        <PreviewModal
                                                            fileSource={downloadFile}
                                                            visibleClose={visible}
                                                            handleModalClose={handleModalClose}
                                                        />
                                                        {/* } */}
                                                    </span>
                                                    <Button
                                                        onClick={handleClickPan}
                                                        variant="outlined"
                                                        color="primary"
                                                        className={classes.uploadBtn}
                                                        disabled={fieldDisable(
                                                            statusId,
                                                            checklist1 &&
                                                                checklist1.questions &&
                                                                checklist1.questions[0] &&
                                                                checklist1.questions[0].fields &&
                                                                checklist1.questions[0].fields[3].relevanceResponseCRC
                                                        )}
                                                    >
                                                        Upload
                                                    </Button>
                                                    <Dialog
                                                        onClose={handleClosePan}
                                                        PaperProps={{
                                                            className: 'QandADailogBox',
                                                            style: { padding: '20px' },
                                                        }}
                                                        aria-labelledby="form-dialog-title"
                                                        open={handleOpenPan}
                                                        clear={clearDataPan}
                                                    >
                                                        <DialogTitle id="form-dialog-title">
                                                            Upload File
                                                            {/* <IconButton
                                                            aria-label="close"
                                                            className={classes.closeButton}
                                                            onClick={handleClosePan}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton> */}
                                                        </DialogTitle>
                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                            <Button
                                                                className="btnOrange"
                                                                variant="outlined"
                                                                component="label"
                                                                color="default"
                                                            >
                                                                <i className="btnIcon">
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                </i>{' '}
                                                                Add File
                                                                <input
                                                                    onChange={(e) => isFileUploadPan(e, e.target.files)}
                                                                    type="file"
                                                                    style={{ display: 'none' }}
                                                                    accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                />
                                                            </Button>
                                                            {filenamePan ? (
                                                                <p className="fileName">
                                                                    {filenamePan.substring(0, 15)}
                                                                    {filenamePan.length > 15 ? '...' : ''}
                                                                </p>
                                                            ) : null}
                                                            {filenamePan ? (
                                                                isfileInvalidPan && isfileInvalidPan.length > 0 ? (
                                                                    <p className="noteCss">Note: {isfileInvalidPan}</p>
                                                                ) : (
                                                                    ''
                                                                )
                                                            ) : null}
                                                        </DialogContent>
                                                        <p className="fileNameGreen">{uploadSuccessfullyPan}</p>
                                                        <DialogActions className="paddingBtm txtCenter">
                                                            <Button
                                                                className={isDisablePan ? classes.disableBtn : 'btnBluepop'}
                                                                onClick={fileUploadPan}
                                                                variant="contained"
                                                                disabled={isDisablePan}
                                                                component="label"
                                                                color="default"
                                                            >
                                                                Upload
                                                            </Button>
                                                            <Button
                                                                className="btnBluepop"
                                                                disabled={uploadSuccessfullyPan.length}
                                                                onClick={handleClosePan}
                                                                variant="contained"
                                                                component="label"
                                                                color="default"
                                                            >
                                                                Cancel
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </div>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="Address-Line-1" shrink>
                                                    Address Line 1 <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[4].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[4].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    id="Address-Line-1"
                                                    name="address1"
                                                    placeholder="Enter Address Line1"
                                                    value={formik.values.address1}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    // onChange={handleChange('amount')}
                                                />
                                                {/* <div className={classes.btnFieldPositionRight}>
                                                <Typography className={classes.bottomLine}>
                                                    {statusId === 6 && userType.value === 'L2 Checklist' &&
                                                    checklist1 &&
                                                    checklist1.questions[0].fields[4].relevanceResponseCRC === 'Relevant'
                                                        ? checklist1 && checklist1.questions[0].fields[4].relevanceResponseCRC
                                                        : ''}
                                                </Typography>
                                            </div> */}
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[4].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[4].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[4].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[4].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[4].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[4].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>

                                                {formik.touched.address1 && formik.errors.address1 ? (
                                                    <span className="validationError">{formik.errors.address1}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="Address-Line-2" shrink>
                                                    Address Line 2 <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[5].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[5].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    id="Address-Line-2"
                                                    name="address2"
                                                    placeholder="Enter Address Line2"
                                                    value={formik.values.address2}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    // onChange={handleChange('amount')}
                                                />
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[5].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[5].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[5].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[5].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[5].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[5].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.address2 && formik.errors.address2 ? (
                                                    <span className="validationError">{formik.errors.address2}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel className="lbl" htmlFor="country" shrink>
                                                    {' '}
                                                    Country <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Select
                                                    native
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[6].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[0].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    onChange={(e) => {
                                                        setCountry(e);
                                                        formik.handleChange(e);
                                                    }}
                                                    name="country"
                                                    className="bottom"
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.country}
                                                >
                                                    <option value="">Select Country</option>
                                                    {allCountryOptions(allCountries)}
                                                </Select>
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[8].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[8].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[8].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[8].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[8].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[8].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.country && formik.errors.country ? (
                                                    <span className="itec-validationError">{formik.errors.country}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel className="lbl" htmlFor="state" shrink>
                                                    {' '}
                                                    State <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Select
                                                    native
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[7].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[0].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    className="bottom"
                                                    name="state"
                                                    value={formik.values.state}
                                                    onChange={(e) => {
                                                        setState(e);
                                                        formik.handleChange(e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                >
                                                    <option value="">Select State</option>
                                                    {allStateOptions(allStates)}
                                                </Select>
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[7].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[7].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[7].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[7].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[7].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[7].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.state && formik.errors.state ? (
                                                    <span className="itec-validationError">{formik.errors.state}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel className="lbl" htmlFor="city" shrink>
                                                    {' '}
                                                    City <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>

                                                <Select
                                                    native
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[8].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[0].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    name="city"
                                                    className="bottom"
                                                    value={formik.values.city}
                                                    onChange={(e) => {
                                                        setCity(e);
                                                        formik.handleChange(e);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                >
                                                    <option value="">Select City</option>
                                                    {allCityOptions(allCities)}
                                                </Select>
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[6].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[6].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[6].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[6].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[6].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[6].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.city && formik.errors.city ? (
                                                    <span className="itec-validationError">{formik.errors.city}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="pin" shrink>
                                                    Pin <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[9].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[9].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    id="pin"
                                                    name="pin"
                                                    placeholder="Enter Pin"
                                                    value={formik.values.pin}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    // onChange={handleChange('amount')}
                                                />
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[9].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[9].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[9].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[9].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[9].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[9].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.pin && formik.errors.pin ? (
                                                    <span className="validationError">{formik.errors.pin}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        {clientType === 'CORPORATE' ||
                                        (checklist1 && checklist1.questions[0].fields[0].response === 'NaN') ? (
                                            ''
                                        ) : (
                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="dob" shrink>
                                                        DOB <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </InputLabel>
                                                    <TextField
                                                        id="date"
                                                        name="dob"
                                                        type="date"
                                                        placeholder="Pick Date"
                                                        format="YYYY/MM/DD"
                                                        // defaultValue="2017-05-24"
                                                        // InputProps={{ inputProps: { max: "9999-12-31" } }}
                                                        InputProps={{ inputProps: { max: moment(new Date()).format('YYYY-MM-DD') } }}
                                                        className={classes.textField}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.dob}
                                                        disabled={fieldDisable(
                                                            statusId,
                                                            checklist1 &&
                                                                checklist1.questions &&
                                                                checklist1.questions[0] &&
                                                                checklist1.questions[0].fields &&
                                                                checklist1.questions[0].fields[10].relevanceResponseCRC
                                                        )}
                                                        //     statusId === 6 &&
                                                        //         checklist1 &&
                                                        //         checklist1.questions[0].fields[10].relevanceResponseCRC === 'Relevant'
                                                        //         ? 'disabled'
                                                        //         : ''
                                                        // }
                                                    />
                                                    <div>
                                                        <Typography className={classes.bottomLine}>
                                                            {statusId === 6 &&
                                                                userType.value === 'L2 Checklist' &&
                                                                (checklist1 &&
                                                                checklist1.questions[0].fields[10].relevanceResponseCRC === 'Relevant' ? (
                                                                    <div className={classes.relevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[10].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[10].relevanceResponseCRC ===
                                                                      'Irrelavant' ? (
                                                                    <div className={classes.irrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[10].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[10].relevanceResponseCRC ===
                                                                      'Paritially Relevant' ? (
                                                                    <div className={classes.partrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[10].relevanceRemarksCRC}
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                ))}
                                                        </Typography>
                                                    </div>
                                                    {formik.touched.dob && formik.errors.dob ? (
                                                        <span className="validationError">{formik.errors.dob}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="mobile-number" shrink>
                                                    Mobile Number <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[11].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[11].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    id="mobile-number"
                                                    name="mobileNo"
                                                    placeholder="Enter Mobile Number"
                                                    value={formik.values.mobileNo}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    // onChange={handleChange('amount')}
                                                />
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[11].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[11].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[11].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[11].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[11].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[11].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.mobileNo && formik.errors.mobileNo ? (
                                                    <span className="validationError">{formik.errors.mobileNo}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                                <InputLabel htmlFor="email-address" shrink>
                                                    Email Address <span style={{ color: '#ff0a047a' }}>*</span>
                                                </InputLabel>
                                                <Input
                                                    className={classes.bottomLine}
                                                    disabled={fieldDisable(
                                                        statusId,
                                                        checklist1 &&
                                                            checklist1.questions &&
                                                            checklist1.questions[0] &&
                                                            checklist1.questions[0].fields &&
                                                            checklist1.questions[0].fields[12].relevanceResponseCRC
                                                    )}
                                                    //     statusId === 6 &&
                                                    //         checklist1 &&
                                                    //         checklist1.questions[0].fields[12].relevanceResponseCRC === 'Relevant'
                                                    //         ? 'disabled'
                                                    //         : ''
                                                    // }
                                                    id="email-address"
                                                    name="emailaddress"
                                                    placeholder="Enter Email Address"
                                                    value={formik.values.emailaddress}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    // onChange={handleChange('amount')}
                                                />
                                                <div>
                                                    <Typography className={classes.bottomLine}>
                                                        {statusId === 6 &&
                                                            userType.value === 'L2 Checklist' &&
                                                            (checklist1 &&
                                                            checklist1.questions[0].fields[12].relevanceResponseCRC === 'Relevant' ? (
                                                                <div className={classes.relevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[12].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[12].relevanceResponseCRC === 'Irrelavant' ? (
                                                                <div className={classes.irrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[12].relevanceRemarksCRC}{' '}
                                                                </div>
                                                            ) : checklist1 &&
                                                              checklist1.questions[0].fields[12].relevanceResponseCRC ===
                                                                  'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {checklist1 && checklist1.questions[0].fields[12].relevanceRemarksCRC}
                                                                </div>
                                                            ) : (
                                                                ''
                                                            ))}
                                                    </Typography>
                                                </div>
                                                {formik.touched.emailaddress && formik.errors.emailaddress ? (
                                                    <span className="validationError">{formik.errors.emailaddress}</span>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                        {clientType === 'CORPORATE' ||
                                        (checklist1 && checklist1.questions[0].fields[0].response === 'NaN') ? (
                                            ''
                                        ) : (
                                            <Grid item xs={12} sm={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="passport-number" shrink>
                                                        Passport Number
                                                    </InputLabel>
                                                    <Input
                                                        className={classes.bottomLine}
                                                        disabled={fieldDisable(
                                                            statusId,
                                                            checklist1 &&
                                                                checklist1.questions &&
                                                                checklist1.questions[0] &&
                                                                checklist1.questions[0].fields &&
                                                                checklist1.questions[0].fields[13].relevanceResponseCRC
                                                        )}
                                                        //     statusId === 6 &&
                                                        //         checklist1 &&
                                                        //         checklist1.questions[0].fields[13].relevanceResponseCRC === 'Relevant'
                                                        //         ? 'disabled'
                                                        //         : ''
                                                        // }
                                                        id="passport-number"
                                                        name="passport"
                                                        placeholder="Enter Passport Number"
                                                        value={formik.values.passport}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        // onChange={handleChange('amount')}
                                                    />
                                                    <div>
                                                        <Typography className={classes.bottomLine}>
                                                            {statusId === 6 &&
                                                                userType.value === 'L2 Checklist' &&
                                                                (checklist1 &&
                                                                checklist1.questions[0].fields[13].relevanceResponseCRC === 'Relevant' ? (
                                                                    <div className={classes.relevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[13].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[13].relevanceResponseCRC ===
                                                                      'Irrelavant' ? (
                                                                    <div className={classes.irrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[13].relevanceRemarksCRC}{' '}
                                                                    </div>
                                                                ) : checklist1 &&
                                                                  checklist1.questions[0].fields[13].relevanceResponseCRC ===
                                                                      'Paritially Relevant' ? (
                                                                    <div className={classes.partrelevanceIndicator}>
                                                                        {checklist1 &&
                                                                            checklist1.questions[0].fields[13].relevanceRemarksCRC}
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                ))}
                                                        </Typography>
                                                    </div>
                                                    {formik.touched.passport && formik.errors.passport ? (
                                                        <span className="validationError">{formik.errors.passport}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {clientType === 'CORPORATE' ||
                                        (checklist1 && checklist1.questions[0].fields[0].response === 'NaN') ? (
                                            ''
                                        ) : (
                                            <Grid item xs={12} sm={12}>
                                                <FormControl fullWidth>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        Do you have Aadhaar number?
                                                    </Typography>
                                                    <div>
                                                        <FormControl component="fieldset">
                                                            <RadioGroup
                                                                defaultValue="aadharNo"
                                                                // aria-label="aadhar"
                                                                id="govIDType"
                                                                name="govIDType"
                                                                onChange={formik.handleChange}
                                                                className="radio-option"
                                                                value={formik.values.govIDType}
                                                                onBlur={formik.handleBlur}
                                                            >
                                                                <ul className={classes.inlineDisplay}>
                                                                    <li>
                                                                        <FormControlLabel
                                                                            value="aadharNo"
                                                                            control={<StyledRadio />}
                                                                            label="Aadhaar number"
                                                                            name="govIDType"
                                                                            disabled={fieldDisable(
                                                                                statusId,
                                                                                checklist1 &&
                                                                                    checklist1.questions &&
                                                                                    checklist1.questions[0] &&
                                                                                    checklist1.questions[0].fields &&
                                                                                    checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                            )}
                                                                        />
                                                                    </li>
                                                                    <li>
                                                                        <FormControlLabel
                                                                            value="enrollmentNo"
                                                                            control={<StyledRadio />}
                                                                            label="Enrollment number"
                                                                            name="govIDType"
                                                                            disabled={fieldDisable(
                                                                                statusId,
                                                                                checklist1 &&
                                                                                    checklist1.questions &&
                                                                                    checklist1.questions[0] &&
                                                                                    checklist1.questions[0].fields &&
                                                                                    checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                            )}
                                                                        />
                                                                    </li>
                                                                    <li>
                                                                        <FormControlLabel
                                                                            value="notEnrolled"
                                                                            control={<StyledRadio />}
                                                                            label="Not Enrolled"
                                                                            name="govIDType"
                                                                            disabled={fieldDisable(
                                                                                statusId,
                                                                                checklist1 &&
                                                                                    checklist1.questions &&
                                                                                    checklist1.questions[0] &&
                                                                                    checklist1.questions[0].fields &&
                                                                                    checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                            )}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {govIDType === 'aadharNo' ? (
                                                            <FormControl fullWidth>
                                                                <InputLabel htmlFor="aadhar-number" shrink>
                                                                    Aadhaar Number <span style={{ color: '#ff0a047a' }}>*</span>
                                                                </InputLabel>
                                                                <Input
                                                                    className={classes.bottomLine}
                                                                    disabled={fieldDisable(
                                                                        statusId,
                                                                        checklist1 &&
                                                                            checklist1.questions &&
                                                                            checklist1.questions[0] &&
                                                                            checklist1.questions[0].fields &&
                                                                            checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                    )}
                                                                    //     statusId === 6 &&
                                                                    //         checklist1 &&
                                                                    //         checklist1.questions[0].fields[15].relevanceResponseCRC === 'Relevant'
                                                                    //         ? 'disabled'
                                                                    //         : ''
                                                                    // }
                                                                    id="aadharNo"
                                                                    name="govIDNumber"
                                                                    placeholder="Enter Aadhaar Number"
                                                                    value={formik.values.govIDNumber}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    // onChange={handleChange('amount')}
                                                                />
                                                                <div>
                                                                    <Typography className={classes.bottomLine}>
                                                                        {statusId === 6 &&
                                                                            userType.value === 'L2 Checklist' &&
                                                                            (checklist1 &&
                                                                            checklist1.questions[0].fields[15].relevanceResponseCRC ===
                                                                                'Relevant' ? (
                                                                                <div className={classes.relevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[15]
                                                                                            .relevanceRemarksCRC}{' '}
                                                                                </div>
                                                                            ) : checklist1 &&
                                                                              checklist1.questions[0].fields[15].relevanceResponseCRC ===
                                                                                  'Irrelavant' ? (
                                                                                <div className={classes.irrelevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[15]
                                                                                            .relevanceRemarksCRC}{' '}
                                                                                </div>
                                                                            ) : checklist1 &&
                                                                              checklist1.questions[0].fields[15].relevanceResponseCRC ===
                                                                                  'Paritially Relevant' ? (
                                                                                <div className={classes.partrelevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[15]
                                                                                            .relevanceRemarksCRC}
                                                                                </div>
                                                                            ) : (
                                                                                ''
                                                                            ))}
                                                                    </Typography>
                                                                </div>

                                                                {formik.touched.govIDNumber && formik.errors.govIDNumber ? (
                                                                    <span className="validationError">{formik.errors.govIDNumber}</span>
                                                                ) : null}

                                                                {/* <div className="itec-attachbtndiv"> */}
                                                                <div className={classes.btnFieldPositionRight}>
                                                                    {attachedFileAadhar ? (
                                                                        <span style={{ marginRight: '7px' }}>
                                                                            {attachedFileAadhar.substring(0, 15)}
                                                                            {attachedFileAadhar.length > 15 ? '...' : ''}
                                                                        </span>
                                                                    ) : null}
                                                                    {/* {pathExtension === true ? ( */}
                                                                    {attachedFileAadhar ? (
                                                                        <span onClick={() => handlePreviewModal(URLValue)}>
                                                                            <Tooltip title="Preview">
                                                                                <img
                                                                                    src={PreviewImage}
                                                                                    alt="PreviewImage"
                                                                                    className="fileView"
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    ) : null}
                                                                    {/* ) : (
                                                                        <span onClick={() => downloadCoreFile(downloadPath)}>
                                                                            <Tooltip title="Download">
                                                                                <img
                                                                                    src={downloadImage}
                                                                                    alt="downloadImage"
                                                                                    className="downlaodImg downloadImgTop"
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    )} */}

                                                                    {/* <span onClick={() => downloadCoreFile(index)}>
                                                                <Tooltip title="Download">
                                                                    <img src={downloadImage} alt="downloadImage" className="downlaodImg" />
                                                                </Tooltip>
                                                            </span> */}
                                                                    <label htmlFor="raised-button-file">
                                                                        <Button
                                                                            onClick={handleClick}
                                                                            // variant="raised"
                                                                            // component="span"
                                                                            color="primary"
                                                                            variant="outlined"
                                                                            className={classes.uploadBtn}
                                                                            disabled={fieldDisable(
                                                                                statusId,
                                                                                checklist1 &&
                                                                                    checklist1.questions &&
                                                                                    checklist1.questions[0] &&
                                                                                    checklist1.questions[0].fields &&
                                                                                    checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                            )}
                                                                            // endIcon={<AttachFileIcon />}
                                                                        >
                                                                            Upload
                                                                        </Button>
                                                                    </label>

                                                                    <Dialog
                                                                        onClose={handleClose}
                                                                        PaperProps={{
                                                                            className: 'QandADailogBox',
                                                                            style: { padding: '20px' },
                                                                        }}
                                                                        aria-labelledby="form-dialog-title"
                                                                        // eslint-disable-next-line react/destructuring-assignment
                                                                        open={handleOpen}
                                                                        clear={clearData}
                                                                        // disableBackdropClick
                                                                    >
                                                                        <DialogTitle id="form-dialog-title">
                                                                            Upload File
                                                                            {/* <IconButton
                                                                        aria-label="close"
                                                                        className={classes.closeButton}
                                                                        onClick={handleClose}
                                                                    // onClick={onClose}
                                                                    >
                                                                        <CloseIcon />
                                                                    </IconButton> */}
                                                                        </DialogTitle>
                                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                                            {/* <DialogContentText>Upload a File</DialogContentText> */}

                                                                            <Button
                                                                                className="btnOrange"
                                                                                // disabled={isDisableAddFile}
                                                                                variant="outlined"
                                                                                component="label"
                                                                                // color="default"
                                                                            >
                                                                                <i className="btnIcon">
                                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                                </i>{' '}
                                                                                Add File
                                                                                <input
                                                                                    onChange={(e) => isFileUpload(e, e.target.files)}
                                                                                    type="file"
                                                                                    style={{ display: 'none' }}
                                                                                    accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                                />
                                                                            </Button>
                                                                            {filename ? (
                                                                                <p className="fileName">
                                                                                    {filename.substring(0, 15)}
                                                                                    {filename.length > 15 ? '...' : ''}
                                                                                </p>
                                                                            ) : null}
                                                                            {filename ? (
                                                                                isfileInvalid && isfileInvalid.length > 0 ? (
                                                                                    <p className="noteCss">Note: {isfileInvalid}</p>
                                                                                ) : (
                                                                                    ''
                                                                                )
                                                                            ) : null}

                                                                            {/* <p className="fileName">{filename}</p> */}
                                                                            {/* <p className="errorMsg">{isfileInvalid}</p> */}
                                                                            {/* <div style={{ display: catchErrorDiv }}>
                                                            <p className="errorMsg">{fileuploadMsg400Error}</p>
                                                        </div> */}
                                                                            {/* <p className="errorMsg">{lengthSuccess}</p>
                                                        <p className="errorMsg">{length}</p> */}
                                                                        </DialogContent>
                                                                        <p className="fileNameGreen">{uploadSuccessfully}</p>

                                                                        <DialogActions className="paddingBtm txtCenter">
                                                                            <Button
                                                                                className={isDisable ? classes.disableBtn : 'btnBluepop'}
                                                                                onClick={fileUpload}
                                                                                variant="contained"
                                                                                disabled={isDisable}
                                                                                component="label"
                                                                                // color="default"
                                                                            >
                                                                                {/* <i className="btnIcon">
                                                                            <FontAwesomeIcon icon={faUpload} />
                                                                        </i>{' '} */}
                                                                                Upload
                                                                            </Button>
                                                                            <Button
                                                                                className="btnBluepop"
                                                                                // disabled={isDisableCancel}
                                                                                onClick={handleClose}
                                                                                variant="contained"
                                                                                component="label"
                                                                                // color="default"
                                                                            >
                                                                                {/* <i className="btnIcon">
                                                                            <FontAwesomeIcon icon={faBan} />
                                                                        </i>{' '} */}
                                                                                Cancel
                                                                            </Button>
                                                                            {/* {(showLoader && ( */}
                                                                            {/* <div className={classes.centerAlign} style={{ width: '18%' }}>
                                                            <Button className="submit btnOrange" variant="outlined" fullWidth disabled>
                                                                <CircularProgress size={24} />
                                                            </Button>
                                                        </div> */}
                                                                            {/* // )) || ( */}

                                                                            {/* // )} */}

                                                                            {/* <Button
                                                                        className="btnOrange"
                                                                        onClick={handleClose}
                                                                        // disabled={isDisableClose}
                                                                        variant="contained"
                                                                        component="label"
                                                                        color="default"
                                                                    >
                                                                        <i className="btnIcon">
                                                                            <FontAwesomeIcon icon={faBan} />
                                                                        </i>{' '}
                                                                        Close
                                                                    </Button> */}
                                                                        </DialogActions>
                                                                        {/* <div className="statusTbl" style={{ display: otpDiv }}>
                                                        <TableContainer className="container">
                                                            <Table stickyHeader aria-label="sticky table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>Sl No</TableCell>
                                                                        <TableCell>User Email</TableCell>
                                                                        <TableCell>Status</TableCell>
                                                                        <TableCell>Message</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {fileuploadMsgError.map((row, index) => (
                                                                        <TableRow hover role="checkbox">
                                                                            <TableCell>{index + 1}</TableCell>
                                                                            <TableCell>{row.email}</TableCell>
                                                                            <TableCell>{row.status}</TableCell>
                                                                            <TableCell>{row.message}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </div> */}
                                                                    </Dialog>
                                                                </div>
                                                            </FormControl>
                                                        ) : govIDType === 'enrollmentNo' ? (
                                                            <FormControl fullWidth>
                                                                <InputLabel htmlFor="aadhar-number" shrink>
                                                                    Enrollment Number
                                                                </InputLabel>
                                                                <Input
                                                                    className={classes.bottomLine}
                                                                    disabled={fieldDisable(
                                                                        statusId,
                                                                        checklist1 &&
                                                                            checklist1.questions &&
                                                                            checklist1.questions[0] &&
                                                                            checklist1.questions[0].fields &&
                                                                            checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                    )}
                                                                    //     statusId === 6 &&
                                                                    //         checklist1 &&
                                                                    //         checklist1.questions[0].fields[15].relevanceResponseCRC === 'Relevant'
                                                                    //         ? 'disabled'
                                                                    //         : ''
                                                                    // }
                                                                    id="enrollmentNo"
                                                                    name="govIDNumber"
                                                                    placeholder="Enrollment Number"
                                                                    value={formik.values.govIDNumber}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    // onChange={handleChange('amount')}
                                                                />
                                                                <div>
                                                                    <Typography className={classes.bottomLine}>
                                                                        {statusId === 6 &&
                                                                            userType.value === 'L2 Checklist' &&
                                                                            (checklist1 &&
                                                                            checklist1.questions[0].fields[15].relevanceResponseCRC ===
                                                                                'Relevant' ? (
                                                                                <div className={classes.relevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[15]
                                                                                            .relevanceRemarksCRC}{' '}
                                                                                </div>
                                                                            ) : checklist1 &&
                                                                              checklist1.questions[0].fields[15].relevanceResponseCRC ===
                                                                                  'Irrelavant' ? (
                                                                                <div className={classes.irrelevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[15]
                                                                                            .relevanceRemarksCRC}{' '}
                                                                                </div>
                                                                            ) : checklist1 &&
                                                                              checklist1.questions[0].fields[15].relevanceResponseCRC ===
                                                                                  'Paritially Relevant' ? (
                                                                                <div className={classes.partrelevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[15]
                                                                                            .relevanceRemarksCRC}
                                                                                </div>
                                                                            ) : (
                                                                                ''
                                                                            ))}
                                                                    </Typography>
                                                                </div>

                                                                {formik.touched.govIDNumber && formik.errors.govIDNumber ? (
                                                                    <span className="validationError">{formik.errors.govIDNumber}</span>
                                                                ) : null}
                                                                {/* <div className="itec-attachbtndiv"> */}
                                                                <div className={classes.btnFieldPositionRight}>
                                                                    <span style={{ marginRight: '7px' }}>{attachedFileEnrollment}</span>
                                                                    {attachedFileEnrollment ? (
                                                                        <span onClick={() => handlePreviewModal(URLValue)}>
                                                                            <Tooltip title="Preview">
                                                                                <img
                                                                                    src={PreviewImage}
                                                                                    alt="PreviewImage"
                                                                                    className="fileView"
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    ) : null}

                                                                    {/* <span onClick={() => downloadCoreFile(index)}>
                                                                <Tooltip title="Download">
                                                                    <img src={downloadImage} alt="downloadImage" className="downlaodImg" />
                                                                </Tooltip>
                                                            </span> */}
                                                                    <Button
                                                                        onClick={handleClickNew}
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        className={classes.uploadBtn}
                                                                        disabled={fieldDisable(
                                                                            statusId,
                                                                            checklist1 &&
                                                                                checklist1.questions &&
                                                                                checklist1.questions[0] &&
                                                                                checklist1.questions[0].fields &&
                                                                                checklist1.questions[0].fields[15].relevanceResponseCRC
                                                                        )}
                                                                    >
                                                                        Upload
                                                                    </Button>
                                                                    <Dialog
                                                                        onClose={handleCloseNew}
                                                                        PaperProps={{
                                                                            className: 'QandADailogBox',
                                                                            style: { padding: '20px' },
                                                                        }}
                                                                        aria-labelledby="form-dialog-title"
                                                                        open={handleOpenNew}
                                                                        clear={clearDataNew}
                                                                    >
                                                                        <DialogTitle id="form-dialog-title">
                                                                            Upload File
                                                                            {/* <IconButton
                                                                        aria-label="close"
                                                                        className={classes.closeButton}
                                                                        onClick={handleCloseNew}
                                                                    >
                                                                        <CloseIcon />
                                                                    </IconButton> */}
                                                                        </DialogTitle>
                                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                                            <Button
                                                                                className="btnOrange"
                                                                                variant="outlined"
                                                                                component="label"
                                                                                color="default"
                                                                            >
                                                                                <i className="btnIcon">
                                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                                </i>{' '}
                                                                                Add File
                                                                                <input
                                                                                    onChange={(e) => isFileUploadNew(e, e.target.files)}
                                                                                    type="file"
                                                                                    style={{ display: 'none' }}
                                                                                    accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                                />
                                                                            </Button>

                                                                            {/* <p className="fileName">{attachedFileAadhar}</p> */}
                                                                        </DialogContent>
                                                                        <p className="fileNameGreen">{uploadSuccessfullyNew}</p>
                                                                        <DialogActions className="paddingBtm txtCenter">
                                                                            <Button
                                                                                className="btnBluepop"
                                                                                onClick={fileUploadNew}
                                                                                variant="contained"
                                                                                disabled={isDisableNew}
                                                                                component="label"
                                                                                color="default"
                                                                            >
                                                                                Upload
                                                                            </Button>
                                                                            <Button
                                                                                className="btnBluepop"
                                                                                disabled={uploadSuccessfullyNew.length}
                                                                                onClick={handleCloseNew}
                                                                                variant="contained"
                                                                                component="label"
                                                                                color="default"
                                                                            >
                                                                                Cancel
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                                                                </div>
                                                            </FormControl>
                                                        ) : null}
                                                    </div>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={12}>
                                            <FormControl fullWidth>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Have you registered under GSTIN?
                                                </Typography>
                                                <div>
                                                    <FormControl component="fieldset">
                                                        <RadioGroup
                                                            // defaultValue={checklist1 && checklist1.questions[0].fields[17].response}
                                                            defaultValue="Yes"
                                                            aria-label="yes-no"
                                                            name="radiodata"
                                                            className="radio-option"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            disabled={fieldDisable(
                                                                statusId,
                                                                checklist1 &&
                                                                    checklist1.questions &&
                                                                    checklist1.questions[0] &&
                                                                    checklist1.questions[0].fields &&
                                                                    checklist1.questions[0].fields[18].relevanceResponseCRC
                                                            )}
                                                            // onChange={(e) => {
                                                            //     hanldeYesCondition(e);
                                                            //     formik.setFieldValue('radiodata', e.target.value);
                                                            //     // formik.handleChange()
                                                            // }}
                                                            value={formik.values.radiodata}
                                                        >
                                                            <ul className={classes.inlineDisplay}>
                                                                <li>
                                                                    <FormControlLabel
                                                                        name="radiodata"
                                                                        value="Yes"
                                                                        control={<StyledRadio />}
                                                                        label="Yes"
                                                                        disabled={fieldDisable(
                                                                            statusId,
                                                                            checklist1 &&
                                                                                checklist1.questions &&
                                                                                checklist1.questions[0] &&
                                                                                checklist1.questions[0].fields &&
                                                                                checklist1.questions[0].fields[18].relevanceResponseCRC
                                                                        )}
                                                                    />
                                                                </li>
                                                                <li>
                                                                    <FormControlLabel
                                                                        name="radiodata"
                                                                        value="No"
                                                                        control={<StyledRadio />}
                                                                        label="No"
                                                                        disabled={fieldDisable(
                                                                            statusId,
                                                                            checklist1 &&
                                                                                checklist1.questions &&
                                                                                checklist1.questions[0] &&
                                                                                checklist1.questions[0].fields &&
                                                                                checklist1.questions[0].fields[18].relevanceResponseCRC
                                                                        )}
                                                                    />
                                                                </li>
                                                            </ul>
                                                        </RadioGroup>
                                                    </FormControl>
                                                    {radiodata === 'Yes' ? (
                                                        <>
                                                            <FormControl fullWidth>
                                                                <InputLabel htmlFor="gst" shrink>
                                                                    GSTIN <span style={{ color: '#ff0a047a' }}>*</span>
                                                                </InputLabel>
                                                                <Field name="GSTIN">
                                                                    {(fieldProps) => {
                                                                        const { field, meta } = fieldProps;
                                                                        // const { touched, errors } = form;
                                                                        return (
                                                                            <>
                                                                                <Input
                                                                                    className={classes.bottomLine}
                                                                                    disabled={fieldDisable(
                                                                                        statusId,
                                                                                        checklist1 &&
                                                                                            checklist1.questions &&
                                                                                            checklist1.questions[0] &&
                                                                                            checklist1.questions[0].fields &&
                                                                                            checklist1.questions[0].fields[18]
                                                                                                .relevanceResponseCRC
                                                                                    )}
                                                                                    //     statusId === 6 &&
                                                                                    //         checklist1 &&
                                                                                    //         checklist1.questions[0].fields[18]
                                                                                    //             .relevanceResponseCRC === 'Relevant'
                                                                                    //         ? 'disabled'
                                                                                    //         : ''
                                                                                    // }
                                                                                    id="GSTIN"
                                                                                    placeholder="Enter GSTIN Number"
                                                                                    {...field}
                                                                                />
                                                                                {meta.touched && meta.error ? (
                                                                                    <span className="itec-validationError">
                                                                                        {meta.error}
                                                                                    </span>
                                                                                ) : null}
                                                                            </>
                                                                        );
                                                                    }}
                                                                </Field>
                                                                {/* <Input
                                                                className={classes.bottomLine}
                                                                disabled={
                                                                    statusId === 6 &&
                                                                    checklist1 &&
                                                                    checklist1.questions[0].fields[18].relevanceResponseCRC ===
                                                                        'Relevant'
                                                                        ? 'disabled'
                                                                        : ''
                                                                }
                                                                id="gst"
                                                                name="GSTIN"
                                                                placeholder="Enter GST Number"
                                                                value={formik.values.GSTIN}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                // onChange={handleChange('amount')}
                                                            /> */}
                                                                <div>
                                                                    <Typography className={classes.bottomLine}>
                                                                        {statusId === 6 &&
                                                                            userType.value === 'L2 Checklist' &&
                                                                            (checklist1 &&
                                                                            checklist1.questions[0].fields[18].relevanceResponseCRC ===
                                                                                'Relevant' ? (
                                                                                <div className={classes.relevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[18]
                                                                                            .relevanceRemarksCRC}{' '}
                                                                                </div>
                                                                            ) : checklist1 &&
                                                                              checklist1.questions[0].fields[18].relevanceResponseCRC ===
                                                                                  'Irrelavant' ? (
                                                                                <div className={classes.irrelevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[18]
                                                                                            .relevanceRemarksCRC}{' '}
                                                                                </div>
                                                                            ) : checklist1 &&
                                                                              checklist1.questions[0].fields[18].relevanceResponseCRC ===
                                                                                  'Paritially Relevant' ? (
                                                                                <div className={classes.partrelevanceIndicator}>
                                                                                    {checklist1 &&
                                                                                        checklist1.questions[0].fields[18]
                                                                                            .relevanceRemarksCRC}
                                                                                </div>
                                                                            ) : (
                                                                                ''
                                                                            ))}
                                                                    </Typography>
                                                                </div>
                                                                {/* {formik.touched.GSTIN && formik.errors.GSTIN ? (
                                                                <span className="validationError">{formik.errors.GSTIN}</span>
                                                            ) : null} */}
                                                                <div className={classes.btnFieldPositionRight}>
                                                                    {attachedFileGSTIN ? (
                                                                        <span style={{ marginRight: '7px' }} className="fileName">
                                                                            {attachedFileGSTIN.substring(0, 15)}
                                                                            {attachedFileGSTIN.length > 15 ? '...' : ''}
                                                                        </span>
                                                                    ) : null}
                                                                    {attachedFileGSTIN ? (
                                                                        <span onClick={() => handlePreviewModal(URLValueGstin)}>
                                                                            <Tooltip title="Preview">
                                                                                <img
                                                                                    src={PreviewImage}
                                                                                    alt="PreviewImage"
                                                                                    className="fileView"
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    ) : null}

                                                                    {/* <span onClick={() => downloadCoreFile(index)}>
                                                                <Tooltip title="Download">
                                                                    <img src={downloadImage} alt="downloadImage" className="downlaodImg" />
                                                                </Tooltip>
                                                            </span> */}
                                                                    <Button
                                                                        onClick={handleClickGstin}
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        className={classes.uploadBtn}
                                                                        disabled={fieldDisable(
                                                                            statusId,
                                                                            checklist1 &&
                                                                                checklist1.questions &&
                                                                                checklist1.questions[0] &&
                                                                                checklist1.questions[0].fields &&
                                                                                checklist1.questions[0].fields[18].relevanceResponseCRC
                                                                        )}
                                                                    >
                                                                        Upload
                                                                    </Button>
                                                                    <Dialog
                                                                        onClose={handleCloseGstin}
                                                                        PaperProps={{
                                                                            className: 'QandADailogBox',
                                                                            style: { padding: '20px' },
                                                                        }}
                                                                        aria-labelledby="form-dialog-title"
                                                                        open={handleOpenGstin}
                                                                        clear={clearDataGstin}
                                                                    >
                                                                        <DialogTitle id="form-dialog-title">
                                                                            Upload File
                                                                            {/* <IconButton
                                                                            aria-label="close"
                                                                            className={classes.closeButton}
                                                                            onClick={handleCloseGstin}
                                                                        >
                                                                            <CloseIcon />
                                                                        </IconButton> */}
                                                                        </DialogTitle>
                                                                        <DialogContent style={{ textAlign: 'center' }}>
                                                                            <Button
                                                                                className="btnOrange"
                                                                                variant="outlined"
                                                                                component="label"
                                                                                color="default"
                                                                            >
                                                                                <i className="btnIcon">
                                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                                </i>{' '}
                                                                                Add File
                                                                                <input
                                                                                    onChange={(e) => isFileUploadGstin(e, e.target.files)}
                                                                                    type="file"
                                                                                    style={{ display: 'none' }}
                                                                                    accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                                />
                                                                            </Button>
                                                                            {filenameGstin ? (
                                                                                <p className="fileName">
                                                                                    {filenameGstin.substring(0, 15)}
                                                                                    {filenameGstin.length > 15 ? '...' : ''}
                                                                                </p>
                                                                            ) : null}
                                                                            {/* <p className="fileName">{filenameGstin}</p> */}
                                                                            {filenameGstin ? (
                                                                                isfileInvalidGstin.length > 0 ? (
                                                                                    <p className="noteCss">Note: {isfileInvalidGstin}</p>
                                                                                ) : (
                                                                                    ''
                                                                                )
                                                                            ) : null}
                                                                        </DialogContent>
                                                                        <p className="fileNameGreen">{uploadSuccessfullyGstin}</p>
                                                                        <DialogActions className="paddingBtm txtCenter">
                                                                            <Button
                                                                                className={
                                                                                    isDisableGstin ? classes.disableBtn : 'btnBluepop'
                                                                                }
                                                                                onClick={fileUploadGstin}
                                                                                variant="contained"
                                                                                disabled={isDisableGstin}
                                                                                component="label"
                                                                                color="default"
                                                                            >
                                                                                Upload
                                                                            </Button>
                                                                            <Button
                                                                                className="btnBluepop"
                                                                                disabled={uploadSuccessfullyGstin.length}
                                                                                onClick={handleCloseGstin}
                                                                                variant="contained"
                                                                                component="label"
                                                                                color="default"
                                                                            >
                                                                                Cancel
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                                                                </div>
                                                            </FormControl>
                                                        </>
                                                    ) : null}
                                                </div>
                                            </FormControl>
                                        </Grid>
                                        <Grid container spacing={3} direction="row" justify="space-between" alignItems="baseline">
                                            <Grid item sm={6} className="btnLeftPad">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className="txt-capitalize btnBlue"
                                                    onClick={handleBack}
                                                >
                                                    Back
                                                </Button>
                                            </Grid>
                                            <Grid item sm={6} className="textRight btnSnCSmallDevice">
                                                {showBtnLoader ? (
                                                    <LoaderPopUp showLoader={showBtnLoader} handleClose={handleClose} title="" />
                                                ) : null}
                                                {(showLoaderSubmit && (
                                                    <div className={classes.centerAlign}>
                                                        <Button className={classes.submit} variant="outlined" fullWidth disabled>
                                                            <CircularProgress size={24} />
                                                        </Button>
                                                    </div>
                                                )) || (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className="txt-capitalize btnBlue"
                                                        type="submit"
                                                        disabled={fieldDisable(statusId, '')}
                                                    >
                                                        Save & Continue
                                                    </Button>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {/* <Grid item sm={12}>
                                    <div className="client-checklist-footer">
                                        <ul>
                                            <li>
                                        <Button variant="outlined" color="primary" className="txt-capitalize" onClick={handleBack}>
                                            BACK
                                        </Button>
                                    </li>
                                            <li>
                                                <Button variant="outlined" color="primary" className="txt-capitalize">
                                                    SAVE
                                                </Button>
                                            </li>
                                            <li></li>
                                        </ul>
                                    </div>
                                </Grid> */}
                                </form>
                            </CardContent>
                        </Card>
                    );
                }}
            </Formik>
        </>
    );
}
